import React, { useEffect, useRef, useState } from 'react';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Container,
  Divider,
  FlexboxGrid,
  IconButton,
  Input,
  InputGroup,
  Panel,
  SelectPicker,
  Stack,
  Notification,
  Modal,
  CheckPicker,
  Drawer,
  Table,
  Whisper,
  Tooltip,
  Loader,
  Grid,
  Row
} from 'rsuite';
import SortUpIcon from '@rsuite/icons/SortUp';
import SearchIcon from '@rsuite/icons/Search';
import globalIP from '@/GlobelIP';
import { useInView } from 'react-intersection-observer';
import ReviewPassIcon from '@rsuite/icons/ReviewPass';
import QrcodeIcon from '@rsuite/icons/Qrcode';
import jsPDF from 'jspdf';
import QRCode from 'qrcode-generator';
import axios from 'axios';
import { Icon } from '@rsuite/icons';
import ModalComponent from './CreateFairModal';
import CheckOutlineIcon from '@rsuite/icons/CheckOutline';
import ReactImageMagnify from 'react-image-magnify';
import TrashIcon from '@rsuite/icons/Trash';
import s1 from './template/QR1.jpg';
import s2 from './template/QR6.jpg';
import s3 from './template/QR7.jpg';
import s4 from './template/QR2.jpg';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Navigation } from 'swiper/modules';
import ArrowLeftIcon from '@rsuite/icons/ArrowLeft';
import ArrowRightIcon from '@rsuite/icons/ArrowRight';
import useLabel from '@/clientWeb/hook/Label';
import { Link } from 'react-router-dom';
import ugr from '@/UGRoute';

const { Column, HeaderCell, Cell } = Table;
const data = ['Add to Bucket', 'Remove from bucket', 'View'].map(item => ({
  label: item,
  value: item
}));
const ManageFair = ({ page = '' }) => {
  const [fairname, setFairname] = useState([]);
  const [fairName, setFairName] = useState('');
  const [action, setAction] = useState('View');
  const [data123, setData123] = useState([]);
  const [limit, setLimit] = useState(0);
  const [meteData, setMeteData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCategoryCode, setSelectedCategoryCode] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState([]);
  const [selectedAlias, setSelectedAlias] = useState([]);
  const [selectedpron, setSelectedPron] = useState([]);
  const [selectedpd, setSelectedProd] = useState([]);
  const [selectedmade, setSelectedMade] = useState([]);
  const [selectedsku, setSelectedSku] = useState([]);
  const [selectedColor, setSelectedColor] = useState([]);
  const [selectedFinish, setSelectedFinish] = useState([]);
  const [selectedhsn, setSelectedhsn] = useState([]);
  const [selectedBuyer, setSelectedBuyer] = useState([]);
  const [selectedSearch, setSelectedSearch] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [productCode, setProductCode] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [disableUI, setDisableUI] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [openD, setOpenD] = useState(false);
  const [open, setOpen] = useState(false);
  const { ref, inView } = useInView({
    rootMargin: `0px 0px ${700}px 0px`
  });

  const [categorydata, setCategorydata] = useState([]);
  const [productypedata, setProductypedata] = useState([]);
  const [isLoadingpro, setIsLoadingpro] = useState(false);
  const [aliasdata, setAliasdata] = useState([]);
  const [isLoadingalias, setIsLoadinalias] = useState(false);
  const [proNamedata, setProdNamedata] = useState([]);
  const [isLoadingpron, setIsLoadingpron] = useState(false);
  const [skudata, setSkudata] = useState([]);
  const [isLoadingsku, setIsLoadinsku] = useState(false);
  const [buyernamedata, setBuyerNamedata] = useState([]);
  const [isLoadingbu, setIsLoadingbu] = useState(false);
  const [finishdata, setFinishdata] = useState([]);
  const [isLoadingfin, setIsLoadingfin] = useState(false);
  const [colordata, setColordata] = useState([]);
  const [isLoadingcolor, setIsLoadingcolor] = useState(false);
  const [searchdata, setSearchdata] = useState([]);
  const [isLoadingse, setIsLoadingse] = useState(false);
  const [proDdata, setProdDdata] = useState([]);
  const [isLoadingprod, setIsLoadingprod] = useState(false);
  const [madedata, setMadedata] = useState([]);
  const [isLoadingmade, setIsLoadingmade] = useState(false);
  const [hsndata, setHsndata] = useState([]);

  // const [searchQryBtn, setSearchQryBtn] = useState(false);

  // function searchQry() {
  //   if (searchQuery !== '') {
  //     setData123([])
  //     setSearchQryBtn(true)
  //     console.log("Current Page change :", currentPage, "Now : 1")
  //     fetchDataBasedOnAction()
  //   }
  // }
  // useEffect(() => {
  //   setCurrentPage(1)
  //   if (searchQuery === '') {
  //     setData123([])
  //     console.log("Current Page change :", currentPage, "Now : 1")

  //     setSearchQryBtn(false)
  //     fetchDataBasedOnAction()
  //   }
  // }, [searchQuery])

  useEffect(() => {
    fetchDataFair();
  }, []);
  const fetchDataFair = async () => {
    const response = await fetch(
      `${globalIP}/api/fair-masters?populate=*&filters[fairstatus][$eq]=Active`
    );
    const json = await response.json();
    const processedData = json.data.map(item => ({
      label: item.attributes.fairName,
      value: item.attributes.fairCode
    }));
    setFairname(processedData.sort((a, b) => a.label.localeCompare(b.label)));
  };

  useEffect(() => {
    if (fairname) {
      fetchDatap();
    }
  }, [fairname]);

  // const fetchDatap = async () => {
  //   // console.log("Fair products :", fairname)
  //   const apiUrl = `${globalIP}/api/fair-product-masters?populate=*&filters[faircode][$eq]=${fairname.map(
  //     item => item.value
  //   )}&pagination[page]=1`;
  //   const response = await fetch(apiUrl);
  //   const json = await response.json();
  //   const allData = [];
  //   for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
  //     const pageResponse = await fetch(
  //       `${globalIP}/api/fair-product-masters?populate=*&filters[faircode][$eq]=${fairname.map(
  //         item => item.value
  //       )}&pagination[page]=${page}`
  //     );
  //     const pageJson = await pageResponse.json();
  //     allData.push(...pageJson.data);
  //   }

  //   const prdcdArray = allData.map(item => item.attributes.prdcd);
  //   setProductCode(prdcdArray);
  // };
  const fetchDatap = async () => {
    // ✅ Fetch all in one call with large pageSize
    const response = await fetch(
      `${globalIP}/api/fair-product-masters?populate=*&filters[faircode][$eq]=${fairname[0]?.value}&pagination[pageSize]=10000`
    );
    const json = await response.json();
    const prdcdArray = json.data.map(item => item.attributes.prdcd);
    setProductCode(prdcdArray);
  };

  useEffect(() => {
    if (action === 'View') {
      setData123([]);
      setMeteData(null);
    }
  }, [action]);
  // useEffect(() => {
  //   if (action != 'View') {
  //     fetchDataBasedOnAction();
  //   }
  // }, [
  //   productCode,
  //   action,
  //   // currentPage,
  //   selectedCategoryCode,
  //   selectedProductType,
  //   selectedColor,
  //   selectedFinish,
  //   selectedhsn,
  //   selectedBuyer,
  //   selectedSearch,
  //   selectedAlias,
  //   selectedpron,
  //   selectedpd,
  //   selectedmade,
  //   selectedsku
  // ]);

  // 🔹 1️⃣ Handles search + filter + fair change + debounce
  useEffect(() => {
    if (fairname.length === 0) return;

    const timer = setTimeout(() => {
      // console.log('🔁 Fetching fresh data after search/filter/action change...');
      setCurrentPage(1);
      setData123([]);
      setSelectedRowIds([]);
      fetchDataBasedOnAction();
    }, 500); // debounce delay

    return () => clearTimeout(timer);
  }, [
    fairname,
    searchQuery.trim(),
    action,
    selectedCategoryCode,
    selectedProductType,
    selectedColor,
    selectedFinish,
    selectedhsn,
    selectedBuyer,
    selectedSearch,
    selectedAlias,
    selectedpron,
    selectedpd,
    selectedmade,
    selectedsku
  ]);

  // 🔹 2️⃣ Handles pagination and action switching (Add/View/Remove)
  useEffect(() => {
    if (fairname.length === 0) return;

    // ✅ Only trigger when action is one of the valid ones
    if (action === 'Add to Bucket' || action === 'Remove from bucket' || action === 'View') {
      // console.log(
      //   `📄 Fetch triggered by action/page change → Action: ${action}, Page: ${currentPage}`
      // );
      fetchDataBasedOnAction();
    }
  }, [action, currentPage]);

  const [authst, setAuthst] = useState(true);

  const productCache = useRef(null);
  const allMatchingIds = useRef([]);

  const fetchDataBasedOnAction = async () => {
    if (isLoading) return;
    setIsLoading(true);
    setDisableUI(true);

    try {
      // ✅ 1️⃣ Load products once and cache them
      if (!productCache.current) {
        const productsResp = await axios.get(
          `${globalIP}/api/products?populate=*&pagination[pageSize]=100000`
        );
        productCache.current = productsResp.data.data;
      }

      const allProducts = productCache.current;

      // ✅ 2️⃣ Fetch fair data (filtered by faircode only)
      const fairUrl = `${globalIP}/api/fair-product-masters?populate=*&filters[faircode][$eq]=${fairname[0]?.value}&pagination[pageSize]=1000000`;
      //  const fairUrl = `${globalIP}/api/fair-product-masters?populate=*&filters[faircode][$eq]=${fairname[0]?.value}`;
      const fairResp = await axios.get(fairUrl);
      const allFairs = fairResp.data.data;
      // console.log(allFairs)
      // ✅ 3️⃣ Create map for O(1) lookup
      const productMap = new Map(allProducts.map(p => [p.id.toString(), p]));

      let matchedProducts = [];

      if (action === 'Remove from bucket' || action === 'View') {
        // Match directly using map
        matchedProducts = allFairs
          .map(fair => {
            const matched = productMap.get(fair.attributes.prdcd);
            if (matched) return { ...matched, fairId: fair.id };
            return null;
          })
          .filter(Boolean);

        // ✅ Apply filters (reused function)
        matchedProducts = applyAllFilters(matchedProducts);
        allMatchingIds.current = matchedProducts.map(p => p.id);

        // ✅ SEARCH FILTER FOR ALL ACTIONS WITH TRIM
        if (searchQuery.trim().length > 0) {
          const q = searchQuery.trim().toLowerCase();
          matchedProducts = matchedProducts.filter(p => {
            const a = p.attributes;
            return (
              a.ProductId?.toLowerCase().includes(q) ||
              a.ProductName?.toLowerCase().includes(q) ||
              a.SearchKeyword?.toLowerCase().includes(q) ||
              a.Description?.toLowerCase().includes(q) ||
              a.CategoryName?.toLowerCase().includes(q) ||
              a.ProductTypeName?.toLowerCase().includes(q) ||
              a.ColorName?.toLowerCase().includes(q) ||
              a.FinishName?.toLowerCase().includes(q)
            );
          });
        }

        setData123(matchedProducts);
        setMeteData({ pagination: { total: matchedProducts.length } });
      }

      // ✅ 4️⃣ Add to Bucket Logic
      else if (action === 'Add to Bucket') {
        const fairProductIds = new Set(allFairs.map(f => f.attributes.prdcd));
        let filteredProducts = allProducts.filter(p => !fairProductIds.has(p.id.toString()));

        // Only authorized
        filteredProducts = filteredProducts.filter(p => p.attributes.Authorized === 'Authorised');

        filteredProducts = applyAllFilters(filteredProducts);
        allMatchingIds.current = filteredProducts.map(p => p.id);
        // Search filter with TRIM
        if (searchQuery.trim().length > 0) {
          const q = searchQuery.trim().toLowerCase();
          filteredProducts = filteredProducts.filter(p => {
            const a = p.attributes;
            return (
              a.ProductId?.toLowerCase().includes(q) ||
              a.ProductName?.toLowerCase().includes(q) ||
              a.SearchKeyword?.toLowerCase().includes(q) ||
              a.Description?.toLowerCase().includes(q) ||
              a.CategoryName?.toLowerCase().includes(q) ||
              a.ProductTypeName?.toLowerCase().includes(q) ||
              a.ColorName?.toLowerCase().includes(q) ||
              a.FinishName?.toLowerCase().includes(q)
            );
          });
        }

        // Pagination
        const pageSize = 25;
        const total = filteredProducts.length;
        const start = (currentPage - 1) * pageSize;
        const end = start + pageSize;
        const paginated = filteredProducts.slice(start, end);

        setData123(prev =>
          currentPage === 1
            ? paginated
            : [...prev, ...paginated.filter(p => !prev.some(x => x.id === p.id))]
        );

        setMeteData({
          pagination: {
            total,
            page: currentPage,
            pageSize,
            pageCount: Math.ceil(total / pageSize)
          }
        });
        setLimit(paginated.length);
      }
    } catch (err) {
      console.error('Error fetching data:', err);
    } finally {
      setIsLoading(false);
      setDisableUI(false);
    }
  };

  // ✅ Common reusable filter function
  const applyAllFilters = products => {
    let filtered = [...products];

    const checks = [
      [selectedCategoryCode, 'CategoryCode'],
      [selectedProductType, 'ProductTypeCode'],
      [selectedColor, 'ColorCode'],
      [selectedFinish, 'FinishCode'],
      [selectedhsn, 'HSNCode'],
      [selectedBuyer, 'BuyerName'],
      [selectedSearch, 'SearchKeyword'],
      [selectedpron, 'ProductName'],
      [selectedpd, 'ProductDesigner'],
      [selectedmade, 'MadeBy'],
      [selectedsku, 'BuyerSku']
    ];

    for (const [arr, key] of checks) {
      if (arr.length > 0) {
        filtered = filtered.filter(p => arr.includes(p.attributes[key]));
      }
    }

    // Alias filter
    if (selectedAlias.length > 0) {
      filtered = filtered.filter(p => {
        const id = p.attributes.ProductId?.toLowerCase() || '';
        return selectedAlias.some(alias => id.includes(alias.toLowerCase()));
      });
    }

    return filtered;
  };

  // ✅ Common reusable filter function
  // const applyAllFilters = (products) => {
  //   let filtered = [...products];

  //   const checks = [
  //     [selectedCategoryCode, "CategoryCode"],
  //     [selectedProductType, "ProductTypeCode"],
  //     [selectedColor, "ColorCode"],
  //     [selectedFinish, "FinishCode"],
  //     [selectedhsn, "HSNCode"],
  //     [selectedBuyer, "BuyerName"],
  //     [selectedSearch, "SearchKeyword"],
  //     [selectedpron, "ProductName"],
  //     [selectedpd, "ProductDesigner"],
  //     [selectedmade, "MadeBy"],
  //     [selectedsku, "BuyerSku"]
  //   ];

  //   for (const [arr, key] of checks) {
  //     if (arr.length > 0) {
  //       filtered = filtered.filter(p => arr.includes(p.attributes[key]));
  //     }
  //   }

  //   // Alias filter
  //   if (selectedAlias.length > 0) {
  //     filtered = filtered.filter(p => {
  //       const id = p.attributes.ProductId?.toLowerCase() || "";
  //       return selectedAlias.some(alias => id.includes(alias.toLowerCase()));
  //     });
  //   }

  //   return filtered;
  // };

  useEffect(() => {
    // Reset everything when action changes
    setCurrentPage(1);
    setData123([]);
    setSelectedRowIds([]);
    setMeteData(null);
  }, [action]);

  const handleSearch = value => {
    setSearchQuery(value);
  };
  const handleCheckboxChange = (rowId, checked) => {
    if (checked) {
      setSelectedRowIds(prevSelectedRowIds => [...prevSelectedRowIds, rowId]);
    } else {
      setSelectedRowIds(prevSelectedRowIds =>
        prevSelectedRowIds.filter(selectedRowId => selectedRowId !== rowId)
      );
    }
  };
  // const handleCheckAll = (value, checked) => {
  //   setSelectedRowIds(checked ? data123.map(item => item.id) : []);
  // };
  const handleCheckAll = (value, checked) => {
    if (action === 'Remove from bucket') {
      setSelectedRowIds(checked ? allMatchingIds.current : []);
    } else if (action === "Add to Bucket") {
      setSelectedRowIds(checked ? allMatchingIds.current : []);
    }
    else {
      setSelectedRowIds(checked ? allMatchingIds.current : []);
    }
  };

  const handleCheckAll2 = (value, checked) => {
    setSelectedRowIds(checked ? viewData.map(item => item.id) : []);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  // useEffect(() => {
  //   // console.log('inView', inView);
  //   if (inView && limit && !viewload) {
  //     setCurrentPage(prev => prev + 1);
  //   }
  // }, [inView]);

  // useEffect(() => {
  //   if (!inView || !limit || viewload) return;

  //   const currentMeta = action === 'View' ? viewMeta : meteData;
  //   const currentPageCount = currentMeta?.pagination?.pageCount || 0;

  //   // Only increment if there are more pages
  //   if (currentPage < currentPageCount) {
  //     setCurrentPage(prev => prev + 1);
  //   }
  // }, [inView, meteData, viewMeta, action]);

  const handleCartClose = () => {
    setIsCartOpen(false);
  };
  const [open2, setOpen2] = useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => {
    setCurrentPage(1); // ✅ Reset page
    setData123([]);
    setSelectedRowIds([]); // ✅ selection clear
    fetchDataBasedOnAction();
    setOpen2(false);
    window.location.reload();
  };

  const cmToInch = value => (value / 2.54).toFixed(2);
  const inchToCm = value => (value * 2.54).toFixed(2);
  const [sizeUnit, setSizeUnit] = useState();
  const size = [
    { label: 'CM', value: 'cm' },
    { label: 'Inch', value: 'inch' }
  ];

  const fairmaster = `${globalIP}/api/fair-product-masters`;

  // const submit = async (e, val) => {
  //   if (val == 0) {
  //     setIsLoading(true);
  //     e.preventDefault();
  //     // Iterate over selected products and submit each one individually
  //     for (const selectedProduct of selectedRowIds) {
  //       const selectedProductData = data123.find(product => product.id === selectedProduct);
  //       if (selectedProductData) {
  //         const formData = new FormData();
  //         formData.append(
  //           'data',
  //           JSON.stringify({
  //             faircode: fairname.length > 0 ? fairname[0].value : '',
  //             fairname: fairname.length > 0 ? fairname[0].label : '',
  //             prdcd: String(selectedProductData.id),
  //             aliascd: selectedProductData.attributes.ProductId,
  //             minCost: 0,
  //             avgCost: 0,
  //             maxCost: 0,
  //             currency: 'USD'
  //             // ... other properties
  //           })
  //         );
  //         // Use the product-specific API endpoint for creating a fair-product
  //         const response = await fetch(fairmaster, {
  //           method: 'POST',
  //           body: formData
  //         });
  //         // Handle the response as needed
  //         const data = await response.json();
  //         console.log(data);
  //       }
  //     }
  //     setIsLoading(false);
  //     handleOpen2();
  //   } else {
  //     setOpenq(true);
  //   }
  // };
  const submit = async (e, val) => {
    e.preventDefault();

    if (val === 0) {
      setIsLoading(true);

      try {
        // Map each selected ID to the product object from cache
        const selectedProductsData = selectedRowIds
          .map(id => productCache.current.find(p => p.id === id))
          .filter(Boolean);
        // Create an array of fetch promises
        const promises = selectedProductsData.map(async product => {
          const formData = new FormData();
          formData.append(
            "data",
            JSON.stringify({
              faircode: fairname.length > 0 ? fairname[0].value : "",
              fairname: fairname.length > 0 ? fairname[0].label : "",
              prdcd: String(product.id),
              aliascd: product.attributes.ProductId,
              minCost: 0,
              avgCost: 0,
              maxCost: 0,
              currency: "USD"
            })
          );

          const response = await fetch(fairmaster, {
            method: "POST",
            body: formData
          });

          return response.json();
        });

        // Wait for all requests to complete
        await Promise.all(promises);

        fetchDataBasedOnAction();
        setSelectedRowIds([]);
        handleOpen2();
      } catch (err) {
        console.error("Submit error:", err);
      } finally {
        setIsLoading(false);
      }
    } else {
      setOpenq(true);
    }
  };


  const submitwithqr = async () => {
    for (const selectedProduct of selectedRowIds) {
      const selectedProductData = data123.find(product => product.id === selectedProduct);
      if (selectedProductData) {
        const formData = new FormData();
        formData.append(
          'data',
          JSON.stringify({
            faircode: fairname.length > 0 ? fairname[0].value : '',
            fairname: fairname.length > 0 ? fairname[0].label : '',
            prdcd: String(selectedProductData.id),
            aliascd: selectedProductData.attributes.ProductId,
            minCost: 0,
            avgCost: 0,
            maxCost: 0,
            currency: 'USD'
            // ... other properties
          })
        );
        // Use the product-specific API endpoint for creating a fair-product
        const response = await fetch(fairmaster, {
          method: 'POST',
          body: formData
        });
        // Handle the response as needed
        const data = await response.json();
        // console.log(data);
      }
    }
    setIsLoading(false);
    handleOpen2();
    setOpenq(false);
  };
  //// QR CODE ////
  const [data1, setData1] = useState([]);
  useEffect(() => {
    fetchDatacd();
  }, []);
  const fetchDatacd = async () => {
    const response = await fetch(`${globalIP}/api/company-details?populate=*`);
    const json = await response.json();
    setAuthst(json.data[0]?.attributes.Authorised);
    setData1(json.data);
  };
  const loadImageDimensions = url => {
    return new Promise(resolve => {
      const img = new Image();
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.src = url;
    });
  };
  const loadImageSafe = async url => {
    try {
      const dimensions = await loadImageDimensions(url);
      return dimensions;
    } catch (error) {
      console.error(`Failed to load image from URL: ${url}`, error);
      return null; // Return null if the image fails to load
    }
  };
  const [isQRLoading1, setIsQRLoading1] = useState(false)
  const [isQRLoading2, setIsQRLoading2] = useState(false)
  const [isQRLoading3, setIsQRLoading3] = useState(false)
  const [isQRLoading4, setIsQRLoading4] = useState(false)
  const [isQRLoading5, setIsQRLoading5] = useState(false)
  const [isQRLoading6, setIsQRLoading6] = useState(false)
  const handleDownloadQR = async productData => {
    setIsQRLoading1(true)
    // console.log(productData)
    const pdf = new jsPDF();
    const logoUrl = data1.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
    const img = `${globalIP}${logoUrl}`;
    const boxWidth = 99;
    const boxHeight = 56;
    const boxesPerRow = 2; // Number of boxes per row
    const maxBoxesPerPage = 10;
    // Iterate over each product in productData
    // if (productData.length === 0) {
    //   alert('No rows selected for export QR Code2!');
    //   return;
    // }
    for (const [index, product] of productData.entries()) {
      if (index % maxBoxesPerPage === 0 && index !== 0) {
        pdf.addPage();
      }
      const relativeIndex = index % maxBoxesPerPage;
      const row = Math.floor(relativeIndex / boxesPerRow);
      const col = relativeIndex % boxesPerRow;
      // Calculate the starting point of each box based on row and column
      const boxX = 2 + col * (boxWidth + 2); // 5 is the horizontal margin between boxes
      const boxY = 3 + row * (boxHeight + 3); // 5 is the vertical margin between boxes
      // Draw a box for each product
      pdf.rect(boxX, boxY, boxWidth, boxHeight);
      // Define the box properties for the logo within each box
      // const logoWidth = 22; // Adjust the logo width as needed
      // const logoHeight = 7; // Adjust the logo height as needed
      // const logoX = 6 + boxX; // Adjust the X position as needed
      // const logoY = 1 + boxY; // Adjust the Y position as needed
      const logoXi = 55 + boxX; // Adjust the X position as needed
      const logoYi = 7 + boxY; // Adjust the Y position as needed
      // Add the logo to the PDF within each box
      const img1 = product.image;
      if (img1) {
        const imgp = img1 ? `${globalIP}${img1}` : '';
        const productImageDimensions = await loadImageDimensions(imgp);
        const maxImageWidth = 30; // Adjust to fit the container
        const maxImageHeight = 30;

        let productImageWidth = productImageDimensions.width;
        let productImageHeight = productImageDimensions.height;

        const widthRatio = maxImageWidth / productImageWidth;
        const heightRatio = maxImageHeight / productImageHeight;
        const scaleRatio = Math.min(widthRatio, heightRatio);

        if (scaleRatio < 1) {
          productImageWidth *= scaleRatio;
          productImageHeight *= scaleRatio;
        }

        // Center the image within the container
        const centeredX = 55 + boxX + (maxImageWidth - productImageWidth) / 2;
        const centeredY = 7 + boxY + (maxImageHeight - productImageHeight) / 2;

        pdf.addImage(imgp, 'JPEG', centeredX, centeredY, productImageWidth, productImageHeight);
      }

      // Add the logo with similar scaling and positioning logic
      const logoDimensions = await loadImageDimensions(img);
      const maxLogoWidth = 22;
      const maxLogoHeight = 7;

      let logoWidth = logoDimensions.width;
      let logoHeight = logoDimensions.height;

      const logoWidthRatio = maxLogoWidth / logoWidth;
      const logoHeightRatio = maxLogoHeight / logoHeight;
      const logoScaleRatio = Math.min(logoWidthRatio, logoHeightRatio);

      if (logoScaleRatio < 1) {
        logoWidth *= logoScaleRatio;
        logoHeight *= logoScaleRatio;
      }

      const logoX = 6 + boxX + (maxLogoWidth - logoWidth) / 2;
      const logoY = 1 + boxY + (maxLogoHeight - logoHeight) / 2;

      pdf.setFont('sans-serif', 'bold');
      pdf.setFontSize(8);
      pdf.text('Tag Code :', 6 + boxX, 44 + boxY);
      pdf.text('Name :', 6 + boxX, 48 + boxY);
      pdf.setFont('sans-serif', 'normal');
      pdf.setFontSize(8);
      pdf.text(`${product?.attributes?.ProductCode || product?.pcode}`, 22 + boxX, 44 + boxY); // Adjust X position to place the value after the label
      pdf.text(`${product?.attributes?.ProductName || product?.name}`, 16 + boxX, 48 + boxY);
      const qrCode = QRCode(0, 'L');
      const qrValue =
        product?.attributes?.ProductCode ||
        product?.pcode ||
        product?.attributes?.Variant_Id;

      if (!qrValue) {
        console.warn("QR value missing for product:", product);
        return; // skip this product
      }

      qrCode.addData(qrValue);
      qrCode.make();
      const qrCodeImage = qrCode.createDataURL();
      const qrCodeWidth = 38;
      const qrCodeHeight = 35;
      pdf.addImage(qrCodeImage, 'JPEG', 2 + boxX, boxY + 5.7, qrCodeWidth, qrCodeHeight);
      pdf.addImage(img, 'JPEG', logoX, logoY + 0.5, logoWidth, logoHeight);
      pdf.setFont('sans-serif', 'bold');
      pdf.setFontSize(8);
      pdf.text('Grs Wt :', 55 + boxX, 44 + boxY);
      pdf.text('Net Wt :', 74 + boxX, 44 + boxY);

      pdf.setFont('sans-serif', 'normal');
      pdf.setFontSize(8);
      pdf.text(`${product?.attributes?.GrossWeight || product?.grwt}`, 67 + boxX, 44 + boxY);
      pdf.text(`${product?.attributes?.NetWeight || product?.ntwt}`, 86 + boxX, 44 + boxY);

      pdf.setFont('sans-serif', 'italic', 'bold');
      pdf.text('Powered By :', 6 + boxX, 53 + boxY);
      pdf.setTextColor(24, 61, 104);
      pdf.setFontSize(8);
      pdf.text('ERPDaddy Software Solution(P) Ltd.', 23 + boxX, 53 + boxY);
      pdf.setTextColor(0, 0, 0);
    }
    pdf.save('QRPrint.pdf');
    setIsQRLoading1(false)
  };
  const handleDownloadQR2 = productData => {
    setIsQRLoading2(true)
    const pdf = new jsPDF();
    const logoUrl = data1.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
    const img = `${globalIP}${logoUrl}`;
    const boxWidth = 51;
    const boxHeight = 60;
    const boxesPerRow = 4; // Number of boxes per row
    const maxBoxesPerPage = 20;

    // Load the logo image and calculate its natural dimensions
    const logoImage = new Image();
    logoImage.src = img;

    logoImage.onload = function () {
      const logoWidthRatio = 25; // Target width for the logo in the box
      const logoHeightRatio = 7; // Target height for the logo in the box

      // Calculate natural aspect ratio
      const aspectRatio = logoImage.width / logoImage.height;

      // Adjust the width and height based on the aspect ratio to fit the target area
      let logoWidthAdjusted = logoWidthRatio;
      let logoHeightAdjusted = logoWidthAdjusted / aspectRatio;

      if (logoHeightAdjusted > logoHeightRatio) {
        logoHeightAdjusted = logoHeightRatio;
        logoWidthAdjusted = logoHeightAdjusted * aspectRatio;
      }

      // Iterate over each product in productData
      productData.forEach((product, index) => {
        if (index % maxBoxesPerPage === 0 && index !== 0) {
          pdf.addPage();
        }
        const relativeIndex = index % maxBoxesPerPage;
        const row = Math.floor(relativeIndex / boxesPerRow);
        const col = relativeIndex % boxesPerRow;

        const boxX = 1 + col * (boxWidth + 1);
        const boxY = 1 + row * (boxHeight + 1);

        pdf.rect(boxX, boxY, boxWidth, boxHeight);

        // Add the resized logo to the PDF
        const logoX = 22 + boxX;
        const logoY = 2 + boxY;
        pdf.addImage(img, 'JPEG', logoX, logoY, logoWidthAdjusted, logoHeightAdjusted);

        const qrCode = QRCode(0, 'L');
        const qrValue =
          product?.attributes?.ProductCode ||
          product?.pcode ||
          product?.attributes?.Variant_Id;

        if (!qrValue) {
          console.warn("QR value missing for product:", product);
          return; // skip this product
        }

        qrCode.addData(qrValue);
        qrCode.make();
        const qrCodeImage = qrCode.createDataURL();
        const qrCodeWidth = 40;
        const qrCodeHeight = 40;
        pdf.addImage(qrCodeImage, 'JPEG', 5.5 + boxX, boxY + 9, qrCodeWidth, qrCodeHeight);

        pdf.setFontSize(10);
        pdf.text(`Code : ${qrValue || product?.pcode}`, 15.5 + boxX, 48 + boxY);
        pdf.text('Powered By', 15.5 + boxX, 53 + boxY);
        pdf.setTextColor(46, 120, 204);
        pdf.setFontSize(8);
        pdf.text('ERPDADDY Software Solution(p) Ltd.', 2 + boxX, 58 + boxY);
        pdf.setTextColor(0, 0, 0);
      });

      pdf.save('QRPrint.pdf');
      setIsQRLoading2(false)
    };
  };

  const handleDownloadQR3 = async (productData, data1) => {
    setIsQRLoading3(true)
    const pdf = new jsPDF({ unit: 'mm', format: 'a4' });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 1;

    const logoUrl = data1?.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
    const img = logoUrl ? `${globalIP}${logoUrl}` : null;

    if (productData.length === 0) {
      alert('No rows selected for export QR Code!');
      return;
    }

    let logoBase64 = null;
    if (img) {
      logoBase64 = await loadImageAsBase64(img);
    }

    const blockSpacing = 4; // mm spacing between blocks
    const spacing = 1.5; // mm vertical spacing between logo, QR, and text
    const textAreaHeight = 4; // mm height for text area
    const borderPadding = 1.5; // padding inside border

    let x = margin;
    let y = margin;

    for (let i = 0; i < productData.length; i++) {
      const product = productData[i];

      // Max logo size reduced to fit block
      let actualLogoWidth = 0;
      let actualLogoHeight = 0;
      if (logoBase64) {
        const logoDimensions = await loadImageSafe(img);
        if (logoDimensions) {
          let logoWidth = logoDimensions.width;
          let logoHeight = logoDimensions.height;

          const maxLogoWidth = 30; // max width in mm (~2 cm)
          const maxLogoHeight = 5; // max height in mm

          const scale = Math.min(maxLogoWidth / logoWidth, maxLogoHeight / logoHeight, 1);
          actualLogoWidth = logoWidth * scale;
          actualLogoHeight = logoHeight * scale;
        }
      }

      const qrCodeSize = 24; // 20 mm = 2 cm

      // Calculate total content width and height for border
      const originalContentWidth = Math.max(actualLogoWidth, qrCodeSize) + borderPadding * 2;
      const extraWidth = 2.5; // your requested width increase
      const contentWidth = originalContentWidth + extraWidth;
      const bottomTrim = 2; // Reduce border height from bottom
      const contentHeight =
        actualLogoHeight +
        spacing +
        qrCodeSize +
        spacing +
        textAreaHeight +
        borderPadding * 2 -
        bottomTrim;

      // Check for horizontal page break
      if (x + contentWidth + margin > pageWidth) {
        x = margin;
        y += contentHeight + blockSpacing;
      }

      // Check for vertical page break
      if (y + contentHeight + margin > pageHeight) {
        pdf.addPage();
        x = margin;
        y = margin;
      }

      // Draw border around content
      pdf.setDrawColor(0);
      pdf.setLineWidth(0.3);
      pdf.rect(x, y, contentWidth, contentHeight);

      // Draw logo centered inside border with padding
      if (logoBase64 && actualLogoHeight > 0) {
        const logoX = x + (contentWidth - actualLogoWidth) / 2;
        const logoY = y + borderPadding;
        pdf.addImage(logoBase64, 'PNG', logoX, logoY, actualLogoWidth, actualLogoHeight);
      }

      // Draw QR code below logo
      const qrX = x + (contentWidth - qrCodeSize) / 2;
      const qrY = y + borderPadding + actualLogoHeight + spacing;

      const qrCode = QRCode(0, 'L');
      const qrValue =
        product?.attributes?.ProductCode ||
        product?.pcode ||
        product?.attributes?.Variant_Id;

      if (!qrValue) {
        console.warn("QR value missing for product:", product);
        return; // skip this product
      }
      qrCode.addData(qrValue);
      qrCode.make();
      const qrCodeImage = qrCode.createDataURL(0, 0, { scale: 8, margin: 0 });

      pdf.addImage(qrCodeImage, 'JPEG', qrX, qrY, qrCodeSize, qrCodeSize);

      // Draw text below QR code
      const textY = qrY + qrCodeSize + spacing + 2; // small baseline tweak
      pdf.setFontSize(12);
      pdf.text(`${qrValue || product?.pcode}`, x + contentWidth / 2, textY, { align: 'center' });

      // Move x for next block horizontally
      x += contentWidth + blockSpacing;
    }

    pdf.save('QRPrint.pdf');
    setIsQRLoading3(false)
  };
  const handleDownloadQR6 = async (productData, data1) => {
    setIsQRLoading6(true)
    const pdf = new jsPDF({ unit: 'mm', format: 'a4' });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 1;

    const logoUrl = data1?.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
    const img = logoUrl ? `${globalIP}${logoUrl}` : null;

    if (productData.length === 0) {
      alert('No rows selected for export QR Code!');
      return;
    }

    let logoBase64 = null;
    if (img) {
      logoBase64 = await loadImageAsBase64(img);
    }

    const blockSpacing = 4; // mm spacing between blocks
    const spacing = 1.5; // mm vertical spacing between logo, QR, and text
    const textAreaHeight = 8; // mm height for text area
    const borderPadding = 1.5; // padding inside border

    let x = margin;
    let y = margin;

    for (let i = 0; i < productData.length; i++) {
      const product = productData[i];

      // Max logo size reduced to fit block
      let actualLogoWidth = 0;
      let actualLogoHeight = 0;
      if (logoBase64) {
        const logoDimensions = await loadImageSafe(img);
        if (logoDimensions) {
          let logoWidth = logoDimensions.width;
          let logoHeight = logoDimensions.height;

          const maxLogoWidth = 30; // max width in mm (~2 cm)
          const maxLogoHeight = 5; // max height in mm

          const scale = Math.min(maxLogoWidth / logoWidth, maxLogoHeight / logoHeight, 1);
          actualLogoWidth = logoWidth * scale;
          actualLogoHeight = logoHeight * scale;
        }
      }

      const qrCodeSize = 24; // 20 mm = 2 cm

      // Calculate total content width and height for border
      const originalContentWidth = Math.max(actualLogoWidth, qrCodeSize) + borderPadding * 2;
      const extraWidth = 2.5; // your requested width increase
      const contentWidth = originalContentWidth + extraWidth;
      const bottomTrim = 2; // Reduce border height from bottom
      const contentHeight =
        actualLogoHeight +
        spacing +
        qrCodeSize +
        spacing +
        textAreaHeight +
        borderPadding * 2 -
        bottomTrim;

      // Check for horizontal page break
      if (x + contentWidth + margin > pageWidth) {
        x = margin;
        y += contentHeight + blockSpacing;
      }

      // Check for vertical page break
      if (y + contentHeight + margin > pageHeight) {
        pdf.addPage();
        x = margin;
        y = margin;
      }

      // Draw border around content
      pdf.setDrawColor(0);
      pdf.setLineWidth(0.3);
      pdf.rect(x, y, contentWidth, contentHeight);

      // Draw logo centered inside border with padding
      if (logoBase64 && actualLogoHeight > 0) {
        const logoX = x + (contentWidth - actualLogoWidth) / 2;
        const logoY = y + borderPadding;
        pdf.addImage(logoBase64, 'PNG', logoX, logoY, actualLogoWidth, actualLogoHeight);
      }

      // Draw QR code below logo
      const qrX = x + (contentWidth - qrCodeSize) / 2;
      const qrY = y + borderPadding + actualLogoHeight + spacing;

      const qrCode = QRCode(0, 'L');
      const qrValue =
        product?.attributes?.ProductCode ||
        product?.pcode ||
        product?.attributes?.Variant_Id;

      if (!qrValue) {
        console.warn("QR value missing for product:", product);
        return; // skip this product
      }
      qrCode.addData(qrValue);
      qrCode.make();
      const qrCodeImage = qrCode.createDataURL(0, 0, { scale: 8, margin: 0 });

      pdf.addImage(qrCodeImage, 'JPEG', qrX, qrY, qrCodeSize, qrCodeSize);

      // Draw text below QR code
      const textY = qrY + qrCodeSize + spacing + 2; // small baseline tweak
      pdf.setFontSize(10);
      pdf.text(`${qrValue || product?.pcode}`, x + contentWidth / 2, textY, { align: 'center' });

      const secondLineY = textY + 4; // 4mm below the first line (adjust as needed)
      const hasDimensions =
        product?.attributes?.Length &&
        product?.attributes?.Width &&
        product?.attributes?.Height &&
        product?.attributes?.SizeUnit;

      const computedSize = hasDimensions
        ? `${product.attributes.Length}x${product.attributes.Width}x${product.attributes.Height} ${product.attributes.SizeUnit}`
        : null;

      const sizeValue = computedSize || product?.size || "";

      pdf.setFontSize(10);
      pdf.text(`${sizeValue}`, x + contentWidth / 2, secondLineY, { align: 'center' });

      // Move x for next block horizontally
      x += contentWidth + blockSpacing;
    }

    pdf.save('QRPrint.pdf');
    setIsQRLoading6(false)
  };

  // Utility: Convert image URL to Base64
  const loadImageAsBase64 = url => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = err => reject(err);
      img.src = url;
    });
  };

  const handleDownloadQR4 = async (productData, data1) => {
    setIsQRLoading4(true)
    // Use 'letter' page size
    const pdf = new jsPDF({ unit: 'mm', format: [127, 127] });

    const logoUrl = data1?.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
    const img = logoUrl ? `${globalIP}${logoUrl}` : null;

    if (productData.length === 0) {
      alert('No rows selected for export QR Code!');
      return;
    }
    for (const [index, product] of productData.entries()) {
      if (index !== 0) {
        pdf.addPage(); // new page for every product
      }
      const pageWidth = pdf.internal.pageSize.getWidth();
      const margin = 6.5;
      // Draw QR container box (optional)

      // Add logo
      if (img) {
        const logoDimensions = await loadImageSafe(img);
        if (logoDimensions) {
          const maxLogoWidth = 100;
          const maxLogoHeight = 35;

          let logoWidth = logoDimensions.width;
          let logoHeight = logoDimensions.height;

          const scale = Math.min(maxLogoWidth / logoWidth, maxLogoHeight / logoHeight, 1);
          logoWidth *= scale;
          logoHeight *= scale;

          const logoX = (pageWidth - logoWidth) / 2;
          const logoY = margin;

          pdf.addImage(img, 'JPEG', logoX, logoY, logoWidth, logoHeight);
        }
      }

      // Generate and add QR code
      const qrCode = QRCode(0, 'L');
      const qrValue =
        product?.attributes?.ProductCode ||
        product?.pcode ||
        product?.attributes?.Variant_Id;

      if (!qrValue) {
        console.warn("QR value missing for product:", product);
        return; // skip this product
      }
      qrCode.addData(qrValue);
      qrCode.make();
      const qrCodeImage = qrCode.createDataURL(0, 0, { scale: 8, margin: 0 });

      const qrCodeSize = 70;
      const qrX = (pageWidth - qrCodeSize) / 2;
      const qrY = 30;

      pdf.addImage(qrCodeImage, 'JPEG', qrX, qrY, qrCodeSize, qrCodeSize);

      // Add product code and size text
      const codeText = `Alias Code: ${qrValue || product?.pcode}`;
      const hasDimensions =
        product?.attributes?.Length &&
        product?.attributes?.Width &&
        product?.attributes?.Height &&
        product?.attributes?.SizeUnit;

      const computedSize = hasDimensions
        ? `${product.attributes.Length}x${product.attributes.Width}x${product.attributes.Height} ${product.attributes.SizeUnit}`
        : null;

      const sizeValue = computedSize || product?.size || "";

      const sizeText = sizeValue ? `Size: ${sizeValue}` : "";

      pdf.setFontSize(18);

      // Always render code text
      const codeWidth = pdf.getTextWidth(codeText);
      const codeX = (pageWidth - codeWidth) / 2;
      const codeY = qrY + qrCodeSize + 10;

      pdf.text(codeText, codeX, codeY);

      // Only render size text if it exists
      if (sizeValue) {
        const sizeWidth = pdf.getTextWidth(sizeText);
        const sizeX = (pageWidth - sizeWidth) / 2;
        const sizeY = codeY + 8;

        pdf.text(sizeText, sizeX, sizeY);
      }

    }
    pdf.save('QRPrint.pdf');
    setIsQRLoading4(false)
  };

  const handleDownloadQR5 = async (productData, data1) => {
    setIsQRLoading5(true)
    const pdf = new jsPDF({ unit: 'mm', orientation: 'landscape', format: [127, 228.6] });

    const logoUrl = data1?.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
    const img = logoUrl ? `${globalIP}${logoUrl}` : null;

    if (productData.length === 0) {
      alert('No rows selected for export QR Code!');
      return;
    }
    for (const [index, product] of productData.entries()) {
      if (index !== 0) {
        pdf.addPage(); // new page for every product
      }
      const pageWidth = pdf.internal.pageSize.getWidth();
      const margin = 2;
      // Draw QR container box (optional)
      let startX = 0;
      // Add logo
      if (img) {
        const logoDimensions = await loadImageSafe(img);
        if (logoDimensions) {
          const maxLogoWidth = 75;
          const maxLogoHeight = 22;

          let logoWidth = logoDimensions.width;
          let logoHeight = logoDimensions.height;

          const scale = Math.min(maxLogoWidth / logoWidth, maxLogoHeight / logoHeight, 1);
          logoWidth *= scale;
          logoHeight *= scale;

          const logoX = 15;
          const logoY = margin;

          pdf.addImage(img, 'JPEG', logoX, logoY, 75, logoHeight - 0.5);
          startX = logoX;
        }
      }

      // Generate and add QR code
      const qrCode = QRCode(0, 'L');
      const qrValue =
        product?.attributes?.ProductCode ||
        product?.pcode ||
        product?.attributes?.Variant_Id;

      if (!qrValue) {
        console.warn("QR value missing for product:", product);
        return; // skip this product
      }
      qrCode.addData(qrValue);
      qrCode.make();
      const qrCodeImage = qrCode.createDataURL(0, 0, { scale: 8, margin: 0 });

      const qrCodeSize = 75;
      const qrX = (pageWidth - qrCodeSize) / 2;
      const qrY = 22;

      pdf.addImage(qrCodeImage, 'JPEG', startX, qrY, qrCodeSize, qrCodeSize);

      // Add product code and size text
      const nameX = startX;
      const nameY = 30 + qrCodeSize;
      const nameMaxWidth = 100;
      pdf.setFont('sans-serif', 'bold');
      pdf.text(`Name : `, nameX, nameY);
      const nameLines = pdf.splitTextToSize(product?.attributes?.ProductName || product?.name, nameMaxWidth);
      pdf.setFont('sans-serif', 'normal');
      pdf.text(nameLines, nameX + pdf.getTextWidth('Name : '), nameY);

      const lineHeight = 3.8;
      const nameHeight = nameLines.length * lineHeight;
      let afterNameY = nameY + nameHeight;

      // Material
      // pdf.setFont('sans-serif', 'bold');
      // pdf.text(`Material : `, startX, afterNameY + lineHeight);
      // pdf.setFont('sans-serif', 'normal');
      // pdf.text(
      //   `${product.material}`,
      //   startX + pdf.getTextWidth('Material : '),
      //   afterNameY + lineHeight
      // );

      // Finish
      pdf.setFont('sans-serif', 'bold');
      pdf.text(`Finish : `, startX, afterNameY + lineHeight);
      pdf.setFont('sans-serif', 'normal');
      pdf.text(
        `${product?.attributes?.FinishName || product?.finish}`,
        startX + pdf.getTextWidth('Finish : '),
        afterNameY + lineHeight
      );

      // Net Weight
      pdf.setFont('sans-serif', 'bold');
      pdf.text(`Net Wt : `, 70 * 2.6, afterNameY + lineHeight * 3);
      pdf.setFont('sans-serif', 'normal');
      pdf.text(
        `${product?.attributes?.NetWeight || product?.ntwt}`,
        70 * 2.6 + pdf.getTextWidth('Net Wt : '),
        afterNameY + lineHeight * 3
      );

      const centeredX = startX * 4 + qrCodeSize;
      const centeredY = qrY;
      // Code
      pdf.setFontSize(25);
      pdf.setFont('sans-serif', 'bold');
      pdf.text('Code: ', centeredX, 10);
      pdf.text(`${product?.attributes?.ProductCode || product?.pcode}`, centeredX + pdf.getTextWidth('Code: '), 10);
      pdf.setFontSize(15);

      const img1 = product.image;
      const imgp = img1 ? `${globalIP}${img1}` : null;
      const productImageDimensions = imgp ? await loadImageSafe(imgp) : null;

      if (productImageDimensions) {
        const maxImageWidth = qrCodeSize;
        const maxImageHeight = qrCodeSize;
        let productImageWidth = productImageDimensions.width;
        let productImageHeight = productImageDimensions.height;

        const widthRatio = maxImageWidth / productImageWidth;
        const heightRatio = maxImageHeight / productImageHeight;
        const scaleRatio = Math.min(widthRatio, heightRatio);

        if (scaleRatio < 1) {
          productImageWidth *= scaleRatio;
          productImageHeight *= scaleRatio;
        }

        pdf.addImage(imgp, 'JPEG', centeredX, centeredY, productImageWidth, productImageHeight);
      }
    }
    pdf.save('QRPrint.pdf');
    setIsQRLoading5(false)
  };
  const [maindata, setMainData] = useState([]);
  const [maindataexcel, setMainDataExcel] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([])
  useEffect(() => {
    const selectedProductsData = selectedRowIds
      .map(id => productCache.current.find(p => p.id === id))
      .filter(Boolean);
    setSelectedProducts(selectedProductsData)
  }, [selectedRowIds, productCache])
  // console.log(selectedProducts)
  // useEffect(() => {
  //   if (selectedRowIds.length) {
  //     fetchDataforQR(selectedRowIds);
  //   }
  // }, [selectedRowIds]);

  // Remove this useEffect entirely and call fetchDataforQR only when needed

  // Or if you need to keep some functionality, modify it to be more efficient:
  useEffect(() => {
    // Only fetch when we have selections AND we're about to use QR data
    // Add a condition to prevent unnecessary calls
    if (selectedRowIds.length > 0 && (action === 'View' || isCartOpen)) {
      fetchDataforQR(selectedRowIds);
    }
  }, [selectedRowIds, action, isCartOpen]); // Add dependencies to control when it runs

  // console.log(selectedRowIds)
  const [isLoadingFairData, setIsLoadingFairData] = useState(false)
  const fetchDataforQR = async selectedFairIds => {
    setIsLoadingFairData(true)
    try {
      const allData = [];

      // 1️⃣ Process all selectedFairIds in parallel
      await Promise.all(
        selectedFairIds.map(async fairId => {
          const fairApiUrl = `${globalIP}/api/fair-product-masters/${fairId}`;
          const fairResponse = await fetch(fairApiUrl);
          const fairJson = await fairResponse.json();
          const prdcd = Number(fairJson.data?.attributes?.prdcd);

          if (!prdcd) {
            console.error(`Fair Product Code (prdcd) not found for fairId: ${fairId}`);
            return;
          }

          // console.log('Fair Product Code (prdcd):', prdcd);

          // Fetch product data by product ID (prdcd)
          const apiUrl = `${globalIP}/api/products?filters[id][$eq]=${prdcd}&populate=*&pagination[page]=1`;
          const response = await fetch(apiUrl);
          const json = await response.json();

          for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
            const pageResponse = await fetch(
              `${globalIP}/api/products?filters[id][$eq]=${prdcd}&populate=*&pagination[page]=${page}`
            );
            const pageJson = await pageResponse.json();
            allData.push(...pageJson.data);
          }
        })
      );

      const productData = allData.map(item => ({
        code: item?.attributes?.ProductId ?? '',
        name: item?.attributes?.ProductName ?? '',
        size: `${item?.attributes?.Length ?? ''}x${item?.attributes?.Width ?? ''}x${item?.attributes?.Height ?? ''
          } ${item?.attributes?.SizeUnit ?? ''}`,
        pcode: item?.attributes?.ProductCode ?? '',
        image: item?.attributes?.CoverImage?.data?.attributes?.url ?? '',
        grwt: item?.attributes?.GrossWeight ?? '',
        ntwt: item?.attributes?.NetWeight ?? '',
        material: item?.attributes?.ProductionDetail?.MaterialCode ?? '',
        finish: item?.attributes?.FinishName ?? ''
      }));
      // console.log(productData)
      setMainData(productData);
      setMainDataExcel(allData);
      // console.log('All product data fetched successfully:', productData);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoadingFairData(false)
    }
  };

  //// QR CODE ////

  //// Fair Add ////
  const [fairStatuses, setFairStatuses] = useState({});
  const [fairdata, setFairData] = useState([]);
  const [fairmeta, setFairmeta] = useState(0);
  useEffect(() => {
    fetchDataEnc();
  }, []);
  const fetchDataEnc = async () => {
    const response = await fetch(`${globalIP}/api/fair-masters?populate=*`);
    const json = await response.json();
    const statuses = json.data.reduce((statusObj, fair) => {
      statusObj[fair.id] = fair.attributes.fairstatus;
      return statusObj;
    }, {});
    setFairData(json.data);
    setFairmeta(json.meta.pagination.total);
    setFairStatuses(statuses);
  };
  ///////

  //// remove products /////
  const [getproduct, setGetProduct] = useState([]);

  useEffect(() => {
    if (selectedRowIds.length > 0) {
      fetchDataFairget();
    }
  }, [selectedRowIds]);
  const [loading, setLoading] = useState(false);
  const fetchDataFairget = async () => {
    setLoading(true);
    try {
      const getids = [];
      let selectedidsfilter = '';
      const FilterString = selectedRowIds.map(rowId => `&filters[id][$eq]=${rowId}`).join('&');
      selectedidsfilter = `&${FilterString}`;
      const response1 = await fetch(`${globalIP}/api/products?populate=*${selectedidsfilter}`);
      const json1 = await response1.json();
      const response2 = await fetch(
        `${globalIP}/api/products?populate=*?${selectedidsfilter}&pagination[pageSize]=${json1?.meta?.pagination?.total}`
      );
      const json2 = await response2.json();
      let productcodefilter = '';
      if (json2.data.length > 0) {
        const FilterString = json2.data.map(item => `filters[prdcd][$eq]=${item.id}`).join('&');
        productcodefilter = `&${FilterString}`;
      }
      const response3 = await fetch(
        `${globalIP}/api/fair-product-masters?populate=*${productcodefilter}`
      );
      const json3 = await response3.json();
      const response4 = await fetch(
        `${globalIP}/api/fair-product-masters?populate=*${productcodefilter}&pagination[pageSize]=${json3?.meta?.pagination?.total}`
      );
      const json4 = await response4.json();
      const fairProduct = json4.data;
      if (fairProduct.length > 0) {
        fairProduct.map(item => getids.push(item.id));
      }
      // Set the accumulated IDs in the state
      setGetProduct(getids);
    } catch (error) {
      console.error('Error fetching fair-product data:', error);
    }
    setLoading(false);
  };
  const [open3, setOpen3] = useState(false);
  const handleOpen3 = () => setOpen3(true);
  const handleClose3 = () => {
    setCurrentPage(1); // ✅ Reset page
    setData123([]);
    setOpen3(false);
    window.location.reload();
  };

  // const deleteFairProducts = async () => {
  //   try {
  //     setIsLoading1(true);
  //     // Iterate over each fair product ID and delete it
  //     for (const fairProductId of getproduct) {
  //       const response = await fetch(`${globalIP}/api/fair-product-masters/${fairProductId}`, {
  //         method: 'DELETE'
  //       });

  //       if (response.ok) {
  //         // If the deletion is successful, log the result or perform any necessary actions
  //         console.log(`Fair product with ID ${fairProductId} deleted successfully.`);
  //       } else {
  //         console.error(`Failed to delete fair product with ID ${fairProductId}.`);
  //       }
  //     }
  //     setIsLoading1(false);
  //     handleOpen3();
  //     // After deletion, you may want to update the state or perform any other actions
  //     // For example, fetch data again to refresh the component
  //   } catch (error) {
  //     console.error('Error deleting fair products:', error);
  //   }
  // };

  ///// remove products /////

  ///// api filter search /////

  //   const deleteFairProducts = async () => {
  //   if (selectedRowIds.length === 0) return;

  //   setIsLoading1(true);
  //   try {
  //     const deletePromises = selectedRowIds.map(id =>
  //       fetch(`${globalIP}/api/fair-product-masters/${id}`, { method: "DELETE" })
  //         .then(res => ({ id, status: res.ok ? "success" : "failed" }))
  //         .catch(err => ({ id, status: "error", error: err.message }))
  //     );

  //     const results = await Promise.all(deletePromises);
  //     const deletedIds = results.filter(r => r.status === "success").map(r => r.id);

  //     if (deletedIds.length > 0) {
  //       setData123(prev => prev.filter(item => !deletedIds.includes(item.fairId)));
  //       setSelectedRowIds([]);
  //     }

  //     handleOpen3();
  //   } catch (err) {
  //     console.error("Delete error:", err);
  //     handleOpen3();
  //   } finally {
  //     setIsLoading1(false);
  //   }
  // };

  const deleteFairProducts = async () => {
    if (selectedRowIds.length === 0) return;

    setIsLoading1(true);
    try {
      const deletePromises = selectedRowIds.map(id =>
        fetch(`${globalIP}/api/fair-product-masters/${id}`, { method: 'DELETE' })
      );

      await Promise.all(deletePromises);

      // Refresh data after deletion
      fetchDataBasedOnAction();
      setSelectedRowIds([]);

      handleOpen3();
    } catch (err) {
      console.error('Delete error:', err);
      handleOpen3();
    } finally {
      setIsLoading1(false);
    }
  };

  // useEffect(() => {
  //   fetchData1();
  //   fetchData2();
  //   fetchData3();
  //   fetchData4();
  //   fetchData5();
  //   fetchData6();
  //   fetchData7();
  //   fetchData8();
  //   fetchData9();
  //   fetchData10();
  //   fetchData11();
  //   fetchData12();
  // }, []);

  const fetchData1 = async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    try {
      const response = await fetch(
        `${globalIP}/api/mstcategories?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/mstcategories?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.CategoryName,
          value: item.attributes.CategoryCode
        }));
        allData.push(...processedData);
      }
      setCategorydata(allData.sort((a, b) => a.label.localeCompare(b.label)));
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const fetchData2 = async () => {
    if (isLoadingpro) {
      return;
    }
    setIsLoadingpro(true);
    try {
      const productIdsQueryParam = selectedCategoryCode
        .map(id => `filters[Categorycode][$in][]=${id}`)
        .join('&');
      // Construct the API URL by appending the query parameters
      const apiUrl = `${globalIP}/api/mstproducttypes?${productIdsQueryParam}&populate=*&pagination[page]=1`;

      const response = await fetch(apiUrl);
      const json = await response.json();

      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/mstproducttypes?${productIdsQueryParam}&populate=*&pagination[page]=${page}`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.ProductTypeName,
          value: item.attributes.ProductTypeCode
        }));
        allData.push(...processedData);
      }
      setProductypedata(allData.sort((a, b) => a.label.localeCompare(b.label)));
      setIsLoadingpro(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchData3 = async () => {
    if (isLoadingalias) {
      return;
    }
    setIsLoadinalias(true);
    try {
      const response = await fetch(`${globalIP}/api/fetchs-aliascd`);
      const json = await response.json();
      const processedData = json.map(item => ({
        label: item.ProductId,
        value: item.ProductId
      }));
      setAliasdata(processedData.sort((a, b) => a.label.localeCompare(b.label)));
      setIsLoadinalias(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchData4 = async () => {
    if (isLoadingpron) {
      return;
    }
    setIsLoadingpron(true);
    try {
      const response = await fetch(`${globalIP}/api/products-name`);
      const json = await response.json();
      const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords

      json.forEach(item => {
        if (item.ProductName && !uniqueKeywords.has(item.ProductName)) {
          uniqueKeywords.add(item.ProductName);
        }
      });

      const processedData = Array.from(uniqueKeywords).map(keyword => ({
        label: keyword,
        value: keyword
      }));
      setProdNamedata(processedData.sort((a, b) => a.label.localeCompare(b.label)));
      setIsLoadingpron(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchData5 = async () => {
    if (isLoadingsku) {
      return;
    }
    setIsLoadinsku(true);
    try {
      const response = await fetch(`${globalIP}/api/buyers-sku`);
      const json = await response.json();
      const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords
      json.forEach(item => {
        if (item.BuyerSku && !uniqueKeywords.has(item.BuyerSku)) {
          uniqueKeywords.add(item.BuyerSku);
        }
      });
      const processedData = Array.from(uniqueKeywords).map(keyword => ({
        label: keyword,
        value: keyword
      }));
      setSkudata(processedData.sort((a, b) => a.label.localeCompare(b.label)));
      setIsLoadinsku(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchData6 = async () => {
    if (isLoadingbu) {
      return;
    }
    setIsLoadingbu(true);
    try {
      const response = await fetch(`${globalIP}/api/buyer-details?&pagination[page]=1`);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(`${globalIP}/api/buyer-details?&pagination[page]=${page}`);
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.buyernm,
          value: item.attributes.buyernm
        }));
        allData.push(...processedData);
      }
      setBuyerNamedata(allData.sort((a, b) => a.label.localeCompare(b.label)));
      setIsLoadingbu(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchData7 = async () => {
    if (isLoadingfin) {
      return;
    }
    setIsLoadingfin(true);
    try {
      const response = await fetch(
        `${globalIP}/api/mstfinishes?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/mstfinishes?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.FinishName,
          value: item.attributes.FinishCode
        }));
        allData.push(...processedData);
      }
      setFinishdata(allData.sort((a, b) => a.label.localeCompare(b.label)));
      setIsLoadingfin(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  // const fetchData8 = async () => {
  //   if (isLoadingcolor) {
  //     return;
  //   }
  //   setIsLoadingcolor(true);
  //   try {
  //     const response = await fetch(
  //       `${globalIP}/api/mstcolors?&pagination[page]=1&filters[dis][$ne]=Discontinue`
  //     );
  //     const json = await response.json();
  //     const allData = [];
  //     for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
  //       const pageResponse = await fetch(
  //         `${globalIP}/api/mstcolors?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
  //       );
  //       const pageJson = await pageResponse.json();
  //       const processedData = pageJson.data.map(item => ({
  //         label: item.attributes.ColorName,
  //         value: item.attributes.ColorCode
  //       }));
  //       allData.push(...processedData);
  //     }
  //     setColordata(allData.sort((a, b) => a.label.localeCompare(b.label)));
  //     setIsLoadingcolor(false);
  //   } catch (error) {
  //     console.error('Error fetching category data:', error);
  //   }
  // };

  const fetchData8 = async () => {
    if (isLoadingcolor) return;
    setIsLoadingcolor(true);
    try {
      const response = await fetch(
        `${globalIP}/api/mstcolors?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];

      for (let page = 1; page <= (json.meta?.pagination?.pageCount || 1); page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/mstcolors?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = (pageJson.data || []).map(item => ({
          label: item.attributes?.ColorName || '',
          value: item.attributes?.ColorCode || ''
        }));
        allData.push(...processedData);
      }

      setColordata(
        allData.sort((a, b) => {
          const labelA = a.label || '';
          const labelB = b.label || '';
          return labelA.localeCompare(labelB);
        })
      );
    } catch (error) {
      console.error('Error fetching category data:', error);
    } finally {
      setIsLoadingcolor(false);
    }
  };

  const fetchData9 = async () => {
    if (isLoadingse) {
      return;
    }
    setIsLoadingse(true);
    try {
      const response = await fetch(`${globalIP}/api/searchs-keyword`);
      const json = await response.json();
      const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords

      json.forEach(item => {
        if (item.SearchKeyword && !uniqueKeywords.has(item.SearchKeyword)) {
          uniqueKeywords.add(item.SearchKeyword);
        }
      });

      const processedData = Array.from(uniqueKeywords).map(keyword => ({
        label: keyword,
        value: keyword
      }));
      setSearchdata(processedData.sort((a, b) => a.label.localeCompare(b.label)));
      setIsLoadingse(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchData10 = async () => {
    if (isLoadingprod) {
      return;
    }
    setIsLoadingprod(true);
    try {
      const response = await fetch(`${globalIP}/api/products-designer`);
      const json = await response.json();
      const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords
      json.forEach(item => {
        if (item.ProductDesigner && !uniqueKeywords.has(item.ProductDesigner)) {
          uniqueKeywords.add(item.ProductDesigner);
        }
      });
      const processedData = Array.from(uniqueKeywords).map(keyword => ({
        label: keyword,
        value: keyword
      }));
      setProdDdata(processedData.sort((a, b) => a.label.localeCompare(b.label)));
      setIsLoadingprod(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchData11 = async () => {
    if (isLoadingmade) {
      return;
    }
    setIsLoadingmade(true);
    try {
      const response = await fetch(`${globalIP}/api/mades-by`);
      const json = await response.json();

      const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords
      json.forEach(item => {
        if (item.MadeBy && !uniqueKeywords.has(item.MadeBy)) {
          uniqueKeywords.add(item.MadeBy);
        }
      });
      const processedData = Array.from(uniqueKeywords).map(keyword => ({
        label: keyword,
        value: keyword
      }));
      setMadedata(processedData.sort((a, b) => a.label.localeCompare(b.label)));
      setIsLoadingmade(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchData12 = async () => {
    try {
      const response = await fetch(
        `${globalIP}/api/msthscodes?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/msthscodes?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.hscode,
          value: item.attributes.hscode
        }));
        allData.push(...processedData);
      }
      setHsndata(allData.sort((a, b) => a.label.localeCompare(b.label)));
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const handleFilterDrawerOpen = () => {
    setOpenD(true);

    // Fetch only if not already loaded
    if (categorydata.length === 0) fetchData1();
    if (productypedata.length === 0) fetchData2();
    if (aliasdata.length === 0) fetchData3();
    if (proNamedata.length === 0) fetchData4();
    if (skudata.length === 0) fetchData5();
    if (buyernamedata.length === 0) fetchData6();
    if (finishdata.length === 0) fetchData7();
    if (colordata.length === 0) fetchData8();
    if (searchdata.length === 0) fetchData9();
    if (proDdata.length === 0) fetchData10();
    if (madedata.length === 0) fetchData11();
    if (hsndata.length === 0) fetchData12();
  };
  // const handleCategoryChange = value => {
  //   setSearchQuery('');
  //   setCurrentPage(1);
  //   setSelectedCategoryCode(value);
  // };
  const handleCategoryChange = value => {
    setSearchQuery('');
    setCurrentPage(1);
    setData123([]); // Clear existing data
    setSelectedCategoryCode(value);
  };
  // const handleProductTypeChange = value => {
  //   setSearchQuery('');
  //   setCurrentPage(1); // Reset page when color changes
  //   setSelectedProductType(value);
  // };

  const handleProductTypeChange = value => {
    setSearchQuery('');
    setCurrentPage(1);
    setData123([]); // Clear existing data
    setSelectedProductType(value);
  };

  const handleAliasChange = value => {
    setSearchQuery('');
    setCurrentPage(1); // Reset page when color changes
    setSelectedAlias(value);
  };
  const handleColorChange = value => {
    setSearchQuery('');
    setCurrentPage(1); // Reset page when color changes
    setSelectedColor(value);
  };
  const handleFinishChange = value => {
    setSearchQuery('');
    setCurrentPage(1); // Reset page when color changes
    setSelectedFinish(value);
  };
  const handleHSNChange = value => {
    setSearchQuery('');
    setCurrentPage(1); // Reset page when color changes
    setSelectedhsn(value);
  };
  const handleBuyerChange = value => {
    setSearchQuery('');
    setCurrentPage(1); // Reset page when color changes
    setSelectedBuyer(value);
  };
  const handleSearchChange = value => {
    setSearchQuery('');
    setCurrentPage(1); // Reset page when color changes
    setSelectedSearch(value);
  };

  const handleProNameChange = value => {
    setSearchQuery('');
    setCurrentPage(1); // Reset page when color changes
    setSelectedPron(value);
  };
  const handleProDChange = value => {
    setSearchQuery('');
    setCurrentPage(1); // Reset page when color changes
    setSelectedProd(value);
  };
  const handleMadeChange = value => {
    setSearchQuery('');
    setCurrentPage(1); // Reset page when color changes
    setSelectedMade(value);
  };
  const handleSkuChange = value => {
    setSearchQuery('');
    setCurrentPage(1); // Reset page when color changes
    setSelectedSku(value);
  };
  ///// api filter search /////

  ////// view products //////

  const getFilteredData = () => {
    const trimmedQuery = searchQuery.trim();
    if (!trimmedQuery) return data123;

    const searchLower = trimmedQuery.toLowerCase();

    return data123.filter(item => {
      const attrs = item.attributes;

      // Comprehensive search across all relevant fields
      const searchableFields = [
        'ProductId', // Alias Code
        'ProductName', // Product Name
        'Description', // Description
        'SearchKeyword', // Search Keyword
        'CategoryName', // Category
        'ProductTypeName', // Product Type
        'ColorName', // Color
        'FinishName', // Finish
        'ProductDesigner', // Product Designer
        'MadeBy', // Made By
        'BuyerSku', // Buyer SKU
        'BuyerName', // Buyer Name
        'HSNCode', // HSN Code
        'SizeRange', // Size Range
        'ProductCode' // Product Code
      ];

      return searchableFields.some(field => {
        const value = attrs[field];
        return value && typeof value === 'string' && value.toLowerCase().includes(searchLower);
      });
    });
  };

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${globalIP}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const columns = [
    {
      key: 'Image',
      label: 'Image',
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>Image</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell>
          {rowData => {
            // Define a function to show the enlarged image on hover
            const renderTooltip = imageSrc => (
              <Tooltip style={{ backgroundColor: 'white' }}>
                <img src={imageSrc} alt="Product Image" style={{ width: 400, height: 'auto' }} />
              </Tooltip>
            );

            return (
              <Whisper
                followCursor
                trigger="hover"
                placement="right"
                speaker={renderTooltip(
                  `${globalIP}${rowData.attributes.CoverImage.data.attributes.url}`
                )}
              >
                <img
                  src={`${globalIP}${rowData.attributes.CoverImage.data.attributes.url}`}
                  alt="Product Image"
                  style={{ width: 50, height: 50, marginTop: '-12px' }}
                />
              </Whisper>
            );
          }}
        </Table.Cell>
      )
    },
    {
      key: 'ProductId',
      label: `${label[0]?.attributes.AliasCode}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.AliasCode}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.ProductId}</Cell>
    },
    {
      key: 'Description',
      label: `${label[0]?.attributes.Description}`,
      width: 250,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.Description}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.Description}</Cell>
    },
    {
      key: 'ProductName',
      label: `${label[0]?.attributes.ProductName}`,
      width: 300,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.ProductName}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.ProductName}</Cell>
    },
    {
      key: 'Dimension',
      label: `${label[0]?.attributes.SizeRange}`,
      width: 200,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.SizeRange}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.SizeRange}</Cell>
    },
    {
      key: 'FinishName',
      label: `${label[0]?.attributes.finish}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.finish}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.FinishName}</Cell>
    },
    {
      key: 'ColorName',
      label: `${label[0]?.attributes.color}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.color}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.ColorName}</Cell>
    }
  ];
  const [columnKeys, setColumnKeys] = useState(columns.map(column => column.key));
  const [viewData, setViewData] = useState([]);
  // const [viewMeta, setViewMeta] = useState([]);
  const [viewMeta, setViewMeta] = useState(null);
  const [viewload, setViewLoad] = useState(false);
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);

  //   useEffect(() => {
  //   // Don't proceed if not in view
  //   if (!inView) return;

  //   // Don't load if already loading
  //   if (isLoading || viewload) return;

  //   // Determine which metadata to use based on action
  //   const currentMeta = action === 'View' ? viewMeta : meteData;

  //   // Check if metadata exists and has pagination info
  //   if (!currentMeta?.pagination) return;

  //   const { pageCount } = currentMeta.pagination;

  //   // Only load more if current page is less than total pages
  //   if (currentPage < pageCount) {
  //     console.log(`Loading page ${currentPage + 1} of ${pageCount}`);
  //     setCurrentPage(prev => prev + 1);
  //   } else {
  //     console.log(`All pages loaded. Current: ${currentPage}, Total: ${pageCount}`);
  //   }
  // }, [inView, meteData, viewMeta, action, isLoading, viewload]);

  // Debounce effect for searchQuery

  useEffect(() => {
    // Don't proceed if not in view
    if (!inView) return;

    // Don't load if already loading
    if (isLoading || viewload) return;

    // ✅ Don't paginate when searching - all results are client-side filtered
    if (searchQuery && searchQuery.length > 0) {
      // console.log('Search active - pagination disabled');
      return;
    }

    // Determine which metadata to use based on action
    const currentMeta = action === 'View' ? viewMeta : meteData;

    // Check if metadata exists and has pagination info
    if (!currentMeta?.pagination) return;

    const { pageCount } = currentMeta.pagination;

    // Only load more if current page is less than total pages
    if (currentPage < pageCount) {
      // console.log(`Loading page ${currentPage + 1} of ${pageCount}`);
      setCurrentPage(prev => prev + 1);
    } else {
      console.log(`All pages loaded. Current: ${currentPage}, Total: ${pageCount}`);
    }
  }, [inView, meteData, viewMeta, action, isLoading, viewload, searchQuery]);

  useEffect(() => {
    setSelectedRowIds([]);
    const timer = setTimeout(() => {
      setCurrentPage(1);
      setDebouncedSearchQuery(searchQuery);
    }, 500); // Adjust the debounce delay as needed

    return () => clearTimeout(timer); // Cleanup the timeout if searchQuery changes before the delay
  }, [searchQuery]);

  // Effect that triggers on debouncedSearchQuery
  // useEffect(() => {
  //   if (productCode.length > 0) {
  //   if (action == 'View') {
  //     fetchViewData();
  //   } else {
  //     fetchDataBasedOnAction();
  //   }
  // }
  // }, [debouncedSearchQuery]);

  useEffect(() => {
    if (productCode.length > 0) {
      if (action == 'View') {
        fetchViewData();
        fetchDataBasedOnAction();
      } else {
        fetchDataBasedOnAction();
      }
    }
  }, [productCode, currentPage, debouncedSearchQuery]);

  // useEffect(() => {
  //   if (productCode.length > 0) {
  //     fetchDataBasedOnAction(); // call it for both 'View' and other actions
  //   }
  // }, [productCode, currentPage, debouncedSearchQuery]);

  // const fetchViewData = async () => {
  //   setViewLoad(true);
  //   try {
  //     const excludeProductCodesFilter = productCode
  //       .map(code => `filters[id][$eq]=${code}`)
  //       .join('&');
  //     let searchQryFilter = '';
  //     if (searchQuery.length > 0) {
  //       let searchQryy = searchQuery.trim();
  //       const searchQry = `filters[$or][0][ProductId][$containsi]=${searchQryy}&filters[$or][1][ProductName][$containsi]=${searchQryy}`;
  //       searchQryFilter = `&${searchQry}`;
  //     }

  //     const response = await fetch(
  //       `${globalIP}/api/products?${excludeProductCodesFilter}&populate=*&pagination[page]=${currentPage}&${searchQryFilter}`
  //     );
  //     const json = await response.json();
  //     setLimit(json.data.length);
  //     if (currentPage === 1) {
  //       setViewData(json.data);
  //     } else {
  //       setViewData(prevData => [...prevData, ...json.data]);
  //     }

  //     setViewLoad(false);
  //     setViewMeta(json.meta);
  //   } catch (error) {
  //     console.error('Error fetching category data:', error);
  //   }
  // };
  const fetchViewData = async () => {
    setViewLoad(true);
    try {
      const excludeProductCodesFilter = productCode
        .map(code => `filters[id][$eq]=${code}`)
        .join('&');

      let searchQryFilter = '';
      if (searchQuery.length > 0) {
        const searchQryy = searchQuery.trim();
        const searchQry = `filters[$or][0][ProductId][$containsi]=${searchQryy}&filters[$or][1][ProductName][$containsi]=${searchQryy}`;
        searchQryFilter = `&${searchQry}`;
      }

      const response = await fetch(
        // `${globalIP}/api/products?${excludeProductCodesFilter}&populate=*&pagination[page]=${currentPage}${searchQryFilter}`
        `${globalIP}/api/products?populate=*&pagination[page]=${currentPage}&pagination[pageSize]=10000000${searchQryFilter}`
      );
      const json = await response.json();

      // Safely handle if json.data is null
      const data = json?.data || [];

      setLimit(data.length);

      if (currentPage === 1) {
        setViewData(data);
      } else {
        setViewData(prevData => [...prevData, ...data]);
      }

      setViewLoad(false);
      setViewMeta(json?.meta || {}); // also safe-check meta
    } catch (error) {
      console.error('Error fetching category data:', error);
      setViewLoad(false);
    }
  };

  const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
  const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;
  const CustomCell = CompactCell;
  const CustomHeaderCell = CompactHeaderCell;
  ////// view products ///////

  ////// qr prints ///////
  const [openq, setOpenq] = useState(false);
  ///// qr prints //////
  const [shfilter, setShfilter] = useState(false);
  const csvData = maindataexcel.map(item => {
    const { id, attributes } = item;
    const {
      MaterialCollection,
      ProductionDetail,
      MultipleImage,
      CoverImage,
      Packaging,
      FortyHQ,
      FortyFT,
      TwentyFT,
      Total_CBM,
      publishedAt,
      updatedAt,
      createdAt,
      BuyerSku,
      BuyerName,
      ColorName,
      cbm,
      ProductTypeCode,
      MadeBy,
      ProductDesigner,
      MOQ,
      SearchKeyword,
      ProductCost,
      HSNCode,
      ColorCode,
      FinishCode,
      ProductCode,
      CategoryCode,
      Total_CFT,
      ...restAttributes
    } = attributes;
    let imageUrl;
    if (attributes.CoverImage?.data?.attributes?.url) {
      imageUrl = `${globalIP}${attributes.CoverImage?.data?.attributes?.url || ''}`;
    }
    return {
      id,
      Image: imageUrl,
      ...restAttributes
    };
  });
  const [iscsvLoading, setIsCsvLoading] = useState(false)
  const downloadExcelData = async data => {
    setIsCsvLoading(true)
    // console.log('data');
    // console.log(data);
    const attributesToRemove = [
      'GrossWeight',
      'SellingPriceUnit',
      'Variant_Id',
      'Buyer_Remark',
      'Product_Remark',
      'SellingPriceCurrency',
      'SellingPrice',
      'ProductTypeName'
    ];
    const headerMapping = {
      id: 'Item No.',
      ProductId: 'Alias Code', // Change "ProductId" to "Alias Code" in the header
      NetWeight: 'Net. Wt.',
      CategoryName: 'Category',
      FinishName: 'Finish',
      SizeUnit: 'Item Size',
      ProductName: 'Product Name',
      ProductCost: 'Price'
      // Add more header mappings as needed
    };
    const companyName = data1[0]?.attributes?.cmpnm || 'Your Company Name';
    const logoUrl = data1[0]?.attributes?.Logo?.data?.attributes?.url || '';
    const imag = `${globalIP}${logoUrl}`;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1', {
      properties: {
        tabColor: {
          argb: 'FFC00000' // Adjust tab color as needed
        }
      }
    });
    const companyNameRow = worksheet.addRow([]);
    // Center the text in the cell
    companyNameRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
    // Increase font size and make it bold
    companyNameRow.getCell(1).font = { size: 16, bold: true };
    const conpmayRow = worksheet.getRow(1); // Assuming the header is in the first row
    conpmayRow.height = 30;
    worksheet.mergeCells('A1:M2');
    worksheet.getCell('E1').value = companyName;
    // Add header row

    if (imag) {
      const logoResponse = await fetch(imag);
      const logoImageBuffer = await logoResponse.arrayBuffer();
      const logoImageId = workbook.addImage({
        buffer: logoImageBuffer,
        extension: 'png' // Adjust the image format as needed
      });

      // Insert the logo in a cell to the left of the company name cell
      worksheet.addImage(logoImageId, { tl: { col: 1, row: 0.5 }, ext: { width: 80, height: 40 } });
    }

    const desiredColumnOrder = [
      'id',
      'Image',
      'ProductId',
      'Description',
      'ProductName',
      'SizeUnit',
      'Length',
      'Width',
      'Height',
      'NetWeight',
      'CategoryName',
      'FinishName',
      'ProductCost'

      // ... (other columns)
    ];

    // const header = Object.keys(data[0]).filter(key => !attributesToRemove.includes(key));
    const headerchange = desiredColumnOrder.map(key => headerMapping[key] || key);
    worksheet.addRow([]); // Add an empty row before headers

    worksheet.addRow(['Item No.', 'Image', 'Alias Code', 'Description', 'ProductName', 'Unit']); // Add the 'Item No.' to cells A3 and A4
    worksheet.mergeCells('A3:A4'); // Merge cells for 'Item No.'
    worksheet.mergeCells('B3:B4'); // Merge cells for 'Item No.'
    worksheet.mergeCells('C3:C4');
    worksheet.mergeCells('J3:J4');
    worksheet.mergeCells('K3:K4');
    worksheet.mergeCells('L3:L4');
    worksheet.mergeCells('M3:M4');
    worksheet.mergeCells('D3:D4');
    worksheet.mergeCells('E3:E4');
    worksheet.mergeCells('F3:F4');
    worksheet.getCell('G4').value = 'Master Carton Size';
    worksheet.mergeCells('G4:I4');
    worksheet.getCell('G4').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'cccaca' } // Set the desired color (here it's a shade of red)
    };
    const headerRow = worksheet.getRow(3); // Assuming the header is in the sixth row
    headerRow.values = headerchange; // Populate the headers starting from the sixth row
    headerRow.height = 30; // Adjust the height as needed

    headerRow.eachCell((cell, index) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'cccaca' }
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.border = {
        top: { style: 'medium', color: { argb: '00000000' } }, // Change the color as needed
        left: { style: 'medium', color: { argb: '00000000' } },
        bottom: { style: 'medium', color: { argb: '00000000' } },
        right: { style: 'medium', color: { argb: '00000000' } }
      };
    });
    worksheet.getColumn('B').width = 20; // Adjust the width as needed for column B
    worksheet.getColumn('D').width = 30; // Adjust the width as needed for column B
    worksheet.getColumn('E').width = 20; // Adjust the width as needed for column B
    worksheet.getColumn('F').width = 20; // Adjust the width as needed for column B
    worksheet.getColumn('C').width = 10; // Adjust the width as needed for column B
    worksheet.getColumn('K').width = 20; // Adjust the width as needed for column B
    worksheet.getColumn('L').width = 20; // Adjust the width as needed for column B
    // Fetch and embed images
    for (const item of data) {
      // console.log(item.id);
      const imageUrl = item.Image;

      if (imageUrl) {
        // Fetch the image data and dimensions
        const img = new Image();
        img.src = imageUrl;
        await new Promise(resolve => (img.onload = resolve)); // Wait for the image to load

        const imageWidth = img.width;
        const imageHeight = img.height;
        const maxWidth = 100; // Maximum width in Excel
        const maxHeight = 100; // Maximum height in Excel

        // Calculate dimensions while maintaining aspect ratio
        let finalWidth = maxWidth;
        let finalHeight = (imageHeight / imageWidth) * maxWidth;
        if (finalHeight > maxHeight) {
          finalHeight = maxHeight;
          finalWidth = (imageWidth / imageHeight) * maxHeight;
        }

        // Fetch the image buffer
        const response = await fetch(imageUrl);
        const imageBuffer = await response.arrayBuffer();

        // Embed the image in the worksheet
        const imageId = workbook.addImage({
          buffer: imageBuffer,
          extension: 'png' // Adjust the image format as needed
        });
        //  worksheet.addImage(imageId, {
        //   tl: { col: 1.3, row: worksheet.rowCount - 0.5 }, // Adjust the column as needed
        //   ext: { width: 100, height: 100 } // Adjust the image size as needed
        // });

        // Add the image to the worksheet
        worksheet.addImage(imageId, {
          tl: { col: 1.3, row: worksheet.rowCount + 0.8 }, // Adjust position as needed
          ext: { width: finalWidth, height: finalHeight } // Use calculated dimensions
        });
      }
      // Add a row with data
      const { Length, Width, Height, SizeUnit, Carton_Length, Carton_Width, Carton_Thick } = item;
      const unitString = `${Length}x${Width}x${Height} ${SizeUnit}`;
      const values = desiredColumnOrder.map(key => {
        if (key === 'SizeUnit') {
          return unitString;
        } else if (key === 'Carton_Length') {
          return Carton_Length;
        } else if (key === 'Carton_Thick') {
          return Carton_Width;
        } else if (key === 'Carton_Width') {
          return Carton_Thick;
        } else if (key === 'ProductCost') {
          return `${item[key]} USD`;
        } else if (key !== 'Image') {
          return item[key];
        }
        // return null;
      });
      worksheet.addRow(values);
      // Set the image in a cell in a new row
      // worksheet.addImage(imageId, {
      //   tl: { col: 1.3, row: worksheet.rowCount - 0.5 }, // Adjust the column as needed
      //   ext: { width: 100, height: 100 } // Adjust the image size as needed
      // });
      const rowNumber = worksheet.rowCount;
      const row = worksheet.getRow(rowNumber);
      row.height = 100; // Adjust the height as needed
      row.eachCell((cell, colNumber) => {
        row.getCell(2).border = {
          top: { style: 'medium', color: { argb: '00000000' } }, // Change the color as needed
          left: { style: 'medium', color: { argb: '00000000' } },
          bottom: { style: 'medium', color: { argb: '00000000' } },
          right: { style: 'medium', color: { argb: '00000000' } }
        };
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      });
      worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
        row.eachCell((cell, colNumber) => {
          cell.border = {
            top: { style: 'medium', color: { argb: '00000000' } }, // Change the color as needed
            left: { style: 'medium', color: { argb: '00000000' } },
            bottom: { style: 'medium', color: { argb: '00000000' } },
            right: { style: 'medium', color: { argb: '00000000' } }
          };
          cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        });
      });
    }
    // Generate Excel buffer
    const excelBuffer = await workbook.xlsx.writeBuffer();
    // In a browser environment, you can use Blob and FileSaver to save the file
    const excelData = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    // Save the Excel file
    saveAs(excelData, `Product Details.xlsx`);
    setIsCsvLoading(false)
  };
  const [id, setId] = useState();
  const [openp, setOpenp] = useState(false);
  const [modeldata, setmodeldata] = useState([]);
  const [cost, setCost] = useState({
    totalinr: 0,
    targetcostUSD: 0
  });
  const [selectedImagePath, setSelectedImagePath] = useState('');
  const [calcwidth, setcalcwidth] = useState(1200);
  useEffect(() => {
    if (selectedImagePath?.url) {
      // Create a new Image object
      const img = new Image();
      img.src = globalIP + selectedImagePath?.url;

      // Once the image is loaded, calculate the width
      img.onload = () => {
        const newCalcWidth = (1200 * img.width) / img.height;
        setcalcwidth(newCalcWidth);
        // console.log('calcwidth', newCalcWidth);
      };
    }
    // console.log('selectedImagePath', selectedImagePath);
  }, [selectedImagePath?.url]);
  const [selectedUnit, setSelectedUnit] = useState('inch');
  const { attributesName } = useLabel();
  const [data11, setData11] = useState([]);
  const [imageList, setImageList] = useState([]);
  const defaultImageIndex = 0;
  const [selectedImageIndex, setSelectedImageIndex] = useState(defaultImageIndex);
  useEffect(() => {
    if (id) {
      fetchData1234();
    }
  }, [id]);
  const fetchData1234 = async () => {
    const response = await fetch(`${globalIP}/api/products?populate=*&filters[id][$eq]=${id}`);
    const json = await response.json();
    const filteredData = json.data.filter(item => item.id === id);
    setmodeldata(filteredData);
    if (filteredData[0].attributes.SetStatus === 'Set') {
      setData11(filteredData[0].attributes.SetSizes);
    } else {
      const data = [
        {
          Length: filteredData[0].attributes.Length,
          Width: filteredData[0].attributes.Width,
          Height: filteredData[0].attributes.Height,
          SizeUnit: filteredData[0].attributes.SizeUnit
        }
      ];
      setData11(data);
    }
    const extractedImageList = json.data
      .filter(item => item.attributes.MultipleImage && item.attributes.MultipleImage.data)
      .map(item => item.attributes.MultipleImage.data.map(image => image.attributes.url))
      .flat(); // Flatten the array of arrays
    const coverImage = json.data.map(item => item.attributes.CoverImage.data.attributes.url);
    extractedImageList.unshift(coverImage);
    const prefixed_list = extractedImageList.map(file => globalIP + file);
    setImageList(prefixed_list);
  };
  const unitOptions = [
    { label: 'Inch', value: 'inch' },
    { label: 'CM', value: 'cm' }
  ];
  const handleSizeChange = value => {
    // setSizeUnit(newSizeUnit);
    setSelectedUnit(value);
    const convertedData = convertDimensions(data11, value);
    setData11(convertedData);
  };
  const convertDimensions = (data, selectedUnit) => {
    const conversionFactor = selectedUnit === 'inch' ? 0.393701 : 2.54;

    return data.map(item => {
      // Skip conversion if the SizeUnit matches the selectedUnit
      if (item.SizeUnit === selectedUnit) {
        // console.log('Unchanged data:', item);
        return item;
      }

      // Convert dimensions if SizeUnit does not match the selectedUnit
      let convertedItem = {
        ...item,
        Length: (item.Length || 0) * conversionFactor,
        Width: (item.Width || 0) * conversionFactor,
        Height: (item.Height || 0) * conversionFactor,
        SizeUnit: selectedUnit
      };

      // console.log('Converted data:', convertedItem);
      return convertedItem;
    });
  };

  // const handleNextImage = item => {
  //   setSelectedImageIndex(prevIndex => (prevIndex + 1) % imageList.length);
  // };
  // const handlePrevImage = item => {
  //   setSelectedImageIndex(prevIndex => (prevIndex - 1 + imageList.length) % imageList.length);
  // };
  // useEffect(() => {
  //   console.log('imgindex : ' + selectedImageIndex);
  //   setSelectedImagePath({
  //     url: modeldata[0]?.attributes?.MultipleImage?.data[selectedImageIndex]?.attributes?.url,
  //     id: modeldata[0]?.id,
  //     default: true
  //   });
  // }, [selectedImageIndex]);

  const handleNextImage = item => {
    const totalImages = item?.attributes?.MultipleImage?.data?.length + 1; // Add 1 for the CoverImage
    setSelectedImageIndex(prevIndex => (prevIndex + 1) % totalImages);
  };

  const handlePrevImage = item => {
    const totalImages = item?.attributes?.MultipleImage?.data?.length + 1; // Add 1 for the CoverImage
    setSelectedImageIndex(prevIndex => (prevIndex - 1 + totalImages) % totalImages);
  };

  // useEffect(() => {
  //   const item = modeldata[0]; // Assuming you want the first item in the array

  //   if (!item) {
  //     console.error('Item is undefined');
  //     return;
  //   }

  //   if (selectedImageIndex === 0) {
  //     console.log('imgindex : ' + selectedImageIndex);
  //     // When selected index is 0, set the CoverImage
  //     const coverImageUrl = item?.attributes?.CoverImage?.data?.attributes?.url;
  //     if (coverImageUrl) {
  //       setSelectedImagePath({
  //         url: coverImageUrl,
  //         id: item.id,
  //         default: true
  //       });
  //     } else {
  //       console.error('Cover image not found');
  //     }
  //   } else {
  //     console.log('imgindex11 : ' + selectedImageIndex);
  //     // Otherwise, set the corresponding MultipleImage
  //     const imageIndex = selectedImageIndex - 1; // Subtract 1 because CoverImage is index 0
  //     const selectedImage = item?.attributes?.MultipleImage?.data?.[imageIndex];
  //     if (selectedImage && selectedImage?.attributes?.url) {
  //       setSelectedImagePath({
  //         url: selectedImage?.attributes?.url,
  //         id: item.id,
  //         default: true
  //       });
  //     } else {
  //       console.error('Multiple image not found at index', imageIndex);
  //     }
  //   }
  // }, [selectedImageIndex, modeldata]);

  useEffect(() => {
    if (!modeldata || modeldata.length === 0) {
      console.warn('modeldata is empty or undefined');
      return;
    }

    const item = modeldata[0];

    if (selectedImageIndex === 0) {
      // Set CoverImage
      const coverImageUrl = item?.attributes?.CoverImage?.data?.attributes?.url;
      if (coverImageUrl) {
        setSelectedImagePath({
          url: coverImageUrl,
          id: item.id,
          default: true
        });
      } else {
        console.warn('Cover image not found');
      }
    } else {
      // Set MultipleImage
      const imageIndex = selectedImageIndex - 1;
      const selectedImage = item?.attributes?.MultipleImage?.data?.[imageIndex];
      if (selectedImage?.attributes?.url) {
        setSelectedImagePath({
          url: selectedImage.attributes.url,
          id: item.id,
          default: true
        });
      } else {
        console.warn('Multiple image not found at index', imageIndex);
      }
    }
  }, [selectedImageIndex, modeldata]);

  const handleOpen = (value, prdcd) => {
    setOpenp(true);
    setId(prdcd);
    const filteredData = data123?.filter(item => item.id === prdcd);
    if (filteredData.length > 0) {
      setmodeldata(filteredData);
    } else {
      console.warn('No data found for the selected product ID:', prdcd);
      setmodeldata([]);
    }
  };

  // console.log("Product :", id, modeldata)
  const handleClose = () => {
    setmodeldata(modeldata);
    setId(null);
    setOpenp(false);
  };

  const [finShow, setFinShow] = useState(false);
  const [sizeshow, setSizeShow] = useState(false);
  const [productCosts, setProductCosts] = useState({});
  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${globalIP}/api/company-details`);
      const json = await response.json();
      const extractedData = json.data[0].attributes.FreeSize;
      setSizeShow(extractedData);
      setFinShow(json.data[0].attributes.setFinish);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const displayData = action === 'View' ? viewData : data123;
  const totalProducts =
    action === 'View' ? viewMeta?.pagination?.total : meteData?.pagination?.total;
  //  const fetchProductCost = async (productId) => {
  //   try {
  //     const response = await fetch(
  //       `${globalIP}/api/costings?populate=*&filters[ProductId][$eq]=${productId}`
  //     );
  //     const json = await response.json();

  //     if (json.data && json.data.length > 0) {
  //       setProductCosts(prev => ({
  //         ...prev,
  //         [productId]: {
  //           totalinr: json.data[0].attributes.totalinr,
  //           targetcostUSD: json.data[0].attributes.targetcostUSD
  //         }
  //       }));
  //     } else {
  //       // अगर costing data नहीं मिलता तो default values set करें
  //       setProductCosts(prev => ({
  //         ...prev,
  //         [productId]: {
  //           totalinr: 0,
  //           targetcostUSD: 0
  //         }
  //       }));
  //     }
  //   } catch (error) {
  //     console.error('Error fetching product cost:', error);
  //     setProductCosts(prev => ({
  //       ...prev,
  //       [productId]: {
  //         totalinr: 0,
  //         targetcostUSD: 0
  //       }
  //     }));
  //   }
  // };

  // // जब product data load हो तो costs fetch करें
  // useEffect(() => {
  //   if (data123.length > 0) {
  //     data123.forEach(item => {
  //       fetchProductCost(item.id);
  //     });
  //   }
  // }, [data123]);
  return (
    <>
      <Container className="main">
        <div
          style={{
            justifyContent: 'space-between',
            width: '-webkit-fill-available',
            position: 'fixed',
            height: '195px',
            background: '#fff',
            zIndex: 1
          }}
        >
          <Stack className="table-toolbar" justifyContent="space-between">
            <Stack direction="column" alignItems="flex-start">
              <Stack direction="column" alignItems="flex-start">
                <h3 className="title">Manage Fair</h3>
                <Breadcrumb>
                  <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                  <Breadcrumb.Item active>Fair</Breadcrumb.Item>
                </Breadcrumb>
              </Stack>
              <Stack spacing={5} alignItems="flex-end">
                <Stack direction="column" alignItems="flex-start">
                  <label>Current Fair Name</label>
                  <div id="custom-container" style={{ position: 'relative' }}>
                    <SelectPicker
                      data={fairname}
                      value={fairname.length > 0 ? fairname[0].label : ''}
                      labelKey="label"
                      valueKey="label"
                      style={{ width: 150 }}
                      cleanable={false}
                      onChange={value => setFairName(value)}
                      container={() => document.getElementById('custom-container')}
                    />
                  </div>
                </Stack>

                <Stack direction="column" alignItems="flex-start">
                  <label>Action</label>
                  <div id="custom-container" style={{ position: 'relative' }}>
                    <SelectPicker
                      data={data}
                      value={action}
                      onChange={value => {
                        setAction(value);
                        setCurrentPage(1);
                        setSelectedRowIds([]);
                      }}
                      labelKey="label"
                      valueKey="label"
                      style={{ width: 150 }}
                      cleanable={false}
                      container={() => document.getElementById('custom-container')}
                    />
                  </div>
                </Stack>
                {shfilter &&
                  (action === 'Add to Bucket' ||
                    action === 'Remove from bucket' ||
                    action === 'View') && (
                    <Stack spacing={5}>
                      <Stack direction="column" alignItems="flex-start">
                        <label>{`${label[0]?.attributes.Category}`}</label>
                        <CheckPicker
                          data={categorydata}
                          value={selectedCategoryCode}
                          onChange={handleCategoryChange}
                          placeholder={`${label[0]?.attributes.Category}`}
                          style={{ width: 200 }}
                          menuStyle={{ maxWidth: 250 }}
                        />
                      </Stack>
                      <Stack direction="column" alignItems="flex-start">
                        <label>{`${label[0]?.attributes.ProductType}`}</label>
                        <CheckPicker
                          data={productypedata}
                          placeholder={`${label[0]?.attributes.ProductType}`}
                          value={selectedProductType}
                          onChange={handleProductTypeChange}
                          style={{ width: 150 }}
                          menuStyle={{ maxWidth: 250 }}
                        />
                      </Stack>

                      <Button
                        appearance="default"
                        active
                        onClick={handleFilterDrawerOpen} // ✅ Changed from setOpenD(true)
                        style={{ marginTop: '18px' }}
                      >
                        More Filter
                      </Button>
                    </Stack>
                  )}
                <Stack direction="column" spacing={4} alignItems="flex-start" style={{ paddingBottom: 2 }}>
                  <b>
                    Products: {getFilteredData().length}
                    {action === 'Add to Bucket' &&
                      meteData?.pagination?.total !== undefined &&
                      `/${meteData.pagination.total}`}
                    {action === 'Remove from bucket' && `/${data123.length}`}
                    {action === 'View' && `/${data123.length}`}
                  </b>
                </Stack>
              </Stack>
            </Stack>
            <Stack direction="column" spacing={20} alignItems="flex-end" justifyContent="flex-end">
              <InputGroup inside>
                {/* <Input
                placeholder="Search"
                value={searchQuery}
                onChange={value => handleSearch(value)}
              /> */}
                <Input
                  placeholder="Search"
                  type="text"
                  value={searchQuery}
                  onChange={value => {
                    setSearchQuery(value);
                  }}
                  onKeyDown={event => {
                    if (event.key === 'Enter') {
                      // Trim search query before searching
                      const trimmedQuery = searchQuery.trim();
                      setSearchQuery(trimmedQuery);
                      setCurrentPage(1);
                      setData123([]);
                      setSelectedRowIds([]);
                      fetchDataBasedOnAction();
                    }
                  }}
                />
                <InputGroup.Addon>
                  <SearchIcon />
                </InputGroup.Addon>
              </InputGroup>
              {/* <Stack spacing={5}>
                {data123?.length > 0 && action !== 'View' && (
                  <Checkbox
                    indeterminate={
                      selectedRowIds.length > 0 && selectedRowIds.length < data123?.length
                    }
                    checked={selectedRowIds.length === data123?.length}
                    onChange={handleCheckAll}
                  >
                    Select all
                  </Checkbox>
                )}
                {viewData.length > 0 && action === 'View' && (
                  <Checkbox
                    indeterminate={
                      selectedRowIds.length > 0 && selectedRowIds.length < viewData.length
                    }
                    checked={selectedRowIds.length === viewData.length}
                    onChange={handleCheckAll2}
                  >
                    Select all
                  </Checkbox>
                )}
                {selectedRowIds.length > 0 &&
                  action !== 'Remove from bucket' &&
                  action !== 'Add to Bucket' && (
                    <Stack spacing={5}>
                      <Button
                        appearance="default"
                        active
                        onClick={() => downloadExcelData(csvData)}
                      >
                        Excel
                      </Button>
                      <IconButton
                        icon={<QrcodeIcon />}
                        size="md"
                        onClick={() => setOpenq(true)}
                        active
                      />
                    </Stack>
                  )}
                {action === 'Add to Bucket' && (
                  <Button appearance="default" active onClick={() => setShfilter(!shfilter)}>
                    {shfilter ? 'Hide filter' : 'Show filter'}
                  </Button>
                )}
                <Button appearance="primary" color="cyan" onClick={() => setOpen(true)}>
                  Add Fair/Show
                </Button>
              </Stack> */}
              <Stack spacing={5}>
                {/* Unified Select All Checkbox */}
                {(action === 'Add to Bucket') && displayData?.length > 0 && (
                  <Checkbox
                    indeterminate={
                      selectedRowIds.length > 0 &&
                      selectedRowIds.length < allMatchingIds.current.length
                    }
                    checked={
                      allMatchingIds.current.length > 0 &&
                      selectedRowIds.length === allMatchingIds.current.length
                    }
                    onChange={handleCheckAll}
                  >
                    Select all
                  </Checkbox>
                )}

                {(action === 'Remove from bucket' || action === 'View') && data123?.length > 0 && (
                  <Checkbox
                    indeterminate={
                      selectedRowIds.length > 0 && selectedRowIds.length < getFilteredData().length
                    }
                    checked={
                      getFilteredData().length > 0 &&
                      selectedRowIds.length === getFilteredData().length
                    }
                    onChange={(value, checked) =>
                      setSelectedRowIds(checked ? getFilteredData().map(item => item.fairId) : [])
                    }
                  >
                    Select all
                  </Checkbox>
                )}

                {/* Actions when rows are selected */}
                {selectedRowIds.length > 0 &&
                  action !== 'Remove from bucket' &&
                  action !== 'Add to Bucket' && (
                    <Stack spacing={5}>
                      <Button
                        appearance="default"
                        active
                        onClick={() => downloadExcelData(csvData)}
                        disabled={isLoadingFairData || iscsvLoading}
                        loading={isLoadingFairData || iscsvLoading}
                      >
                        Excel
                      </Button>
                      <IconButton
                        icon={<QrcodeIcon />}
                        size="md"
                        onClick={() => setOpenq(true)}
                        disabled={isLoadingFairData}
                        loading={isLoadingFairData}
                        active
                      />
                    </Stack>
                  )}

                {/* Add to Bucket filter toggle */}
                {/* {action === 'Add to Bucket' && (
                  <Button appearance="default" active onClick={() => setShfilter(!shfilter)}>
                    {shfilter ? 'Hide filter' : 'Show filter'}
                  </Button>
                )} */}

                {/* Filter toggle for all actions except View (or include View if needed) */}
                {(action === 'Add to Bucket' ||
                  action === 'Remove from bucket' ||
                  action === 'View') && (
                    <Button
                      appearance="default"
                      active
                      onClick={() => {
                        setShfilter(!shfilter);
                        fetchData1();
                        fetchData2();
                      }}
                    >
                      {shfilter ? 'Hide filter' : 'Show filter'}
                    </Button>
                  )}

                {/* Always visible Add Fair/Show button */}
                <Button appearance="primary" color="cyan" onClick={() => setOpen(true)}>
                  Add Fair/Show
                </Button>
              </Stack>
            </Stack>
          </Stack>
          <Divider style={{ marginTop: '4px', marginBottom: '5px' }} />
        </div>
        <div className="row" style={{ marginTop: '178px' }}>
          {isLoading && !searchQuery && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'rgba(255,255,255,0.7)',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Loader center size="md" speed="fast" content="Loading..." />
            </div>
          )}
          <Panel
            style={{ pointerEvents: disableUI ? 'none' : 'auto', opacity: disableUI ? 0.5 : 1 }}
          >
            {data123?.length > 0 && (
              <>
                {/* Grid */}
                <FlexboxGrid justify="start" style={{ textAlign: 'center' }}>
                  {getFilteredData().map(item => (
                    <FlexboxGrid.Item
                      as={Col}
                      colspan={24}
                      md={6}
                      className="data-tbl-img"
                      key={item.id}
                    >
                      <Panel
                        className="box"
                        bordered
                        bodyFill
                        style={{ display: 'inline-block', width: '100%', height: '296px' }}
                      >
                        <Stack>
                          {/* <Checkbox
                  value={item.id}
                  checked={selectedRowIds.includes(item.id)}
                  onChange={(value, checked) => handleCheckboxChange(value, checked)}
                /> */}
                          <Stack>
                            {action === 'Add to Bucket' ? (
                              <Checkbox
                                value={item.id} // product ID
                                checked={selectedRowIds.includes(item.id)}
                                onChange={(value, checked) => handleCheckboxChange(value, checked)}
                              />
                            ) : (
                              <Checkbox
                                value={item.fairId} // fair-product-master ID
                                checked={selectedRowIds.includes(item.fairId)}
                                onChange={(value, checked) => handleCheckboxChange(value, checked)}
                              />
                            )}
                          </Stack>
                        </Stack>

                        <div
                          className="image-containerm"
                          // onClick={() =>
                          //   handleCheckboxChange(item.id, !selectedRowIds.includes(item.id))
                          // }
                          onClick={() => {
                            const key = action === 'Remove from bucket' ? item.fairId : item.id;
                            handleCheckboxChange(key, !selectedRowIds.includes(key));
                          }}
                        >
                          <img
                            src={`${globalIP}${item.attributes?.CoverImage?.data?.attributes?.url}`}
                            alt="Image"
                            className="image-style"
                          />
                        </div>

                        <div className="overlay">
                          <Link
                            to={{
                              pathname: `/${ugr}/productView`,
                              search: `?id=${item.id}&variantId=${item.attributes.Variant_Id}&val=${page === 'variant' ? 0 : 1
                                }`
                            }}
                            className="link"
                            target="_blank"
                          >
                            <Button style={{ background: 'rgba(0, 0, 0, -0.5)', color: 'white' }}>
                              Product Details
                            </Button>
                          </Link>
                        </div>

                        <Panel>
                          <b>Product : {item.attributes.ProductName} </b>
                          <p>Alias : {item.attributes.ProductId}</p>
                        </Panel>
                      </Panel>
                    </FlexboxGrid.Item>
                  ))}
                </FlexboxGrid>
                {isLoading && <Loader center size="md" speed="fast" content="loading..." />}
              </>
            )}

            {selectedRowIds.length > 0 &&
              (action === 'Remove from bucket' || action === 'Add to Bucket') && (
                <Notification
                  type="success"
                  onClose={handleCartClose}
                  style={{
                    position: 'fixed',
                    top: '80%',
                    right: 20,
                    transform: 'translateY(-50%)',
                    zIndex: 9999,
                    background: '#0070a9',
                    color: 'white',
                    width: '20%'
                  }}
                >
                  {action === 'Remove from bucket' ? (
                    <>
                      <b style={{ color: 'white' }}> Selected Products : {selectedRowIds.length}</b>
                      <Divider />
                      <IconButton
                        icon={<TrashIcon />}
                        onClick={deleteFairProducts}
                        loading={isLoading1}
                      >
                        <b>Remove</b>
                      </IconButton>
                    </>
                  ) : (
                    <>
                      <b style={{ color: 'white' }}>Add to Cart : {selectedRowIds.length}</b>
                      <Divider />
                      <Stack justifyContent="space-between">
                        <IconButton
                          icon={<ReviewPassIcon />}
                          onClick={e => submit(e, 0)}
                          loading={isLoading || loading}
                        >
                          <b>Add</b>
                        </IconButton>
                        <IconButton icon={<QrcodeIcon />} onClick={e => submit(e, 1)}>
                          <b>Add & QR</b>
                        </IconButton>
                      </Stack>
                    </>
                  )}
                </Notification>
              )}
          </Panel>
        </div>
        {(viewData?.length > 0 || data123?.length > 0) && (
          <Button ref={ref} style={{ visibility: 'hidden' }}></Button>
        )}
        {/* <Button ref={ref} style={{ visibility: 'hidden' }}></Button> */}
        <Stack justifyContent="flex-end">
          <IconButton
            size="sm"
            icon={<SortUpIcon />}
            active
            onClick={scrollToTop}
            style={{
              position: 'fixed',
              top: '90%',
              right: 16,
              transform: 'translateY(-50%)',
              zIndex: 9999
            }}
          />
        </Stack>
        <Modal open={open2} onClose={handleClose2}>
          <Modal.Body>
            <Stack direction="column">
              <Icon
                as={CheckOutlineIcon}
                color="cyan"
                style={{ fontSize: '100px', marginBottom: '20px' }}
              />
              <b>Saved Successfully</b>
            </Stack>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClose2} appearance="primary" color="cyan">
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal open={open3} onClose={handleClose3}>
          <Modal.Body>
            <Stack direction="column">
              <Icon
                as={CheckOutlineIcon}
                color="cyan"
                style={{ fontSize: '100px', marginBottom: '20px' }}
              />
              <b>Removed Successfully</b>
            </Stack>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClose3} appearance="primary" color="cyan">
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
        <Drawer size="xs" open={openD} onClose={() => setOpenD(false)} backdrop="static">
          <Drawer.Header>
            <Drawer.Title>Filter</Drawer.Title>
            <Drawer.Actions>
              <Button onClick={() => setOpenD(false)} appearance="primary" color="cyan">
                Confirm
              </Button>
            </Drawer.Actions>
          </Drawer.Header>
          <Drawer.Body>
            <Stack direction="column" alignItems="center">
              {/* Alias Filter - Fixed for all actions */}
              {/* <CheckPicker
     data={aliasdata.filter(item => {
          if (action === 'Add to Bucket') {
            // For Add to Bucket - check authorization
            const product = data123.find(p => p.attributes.ProductId === item.value);
            return product && product.attributes.Authorized === 'Authorised';
          } else if (action === 'Remove from bucket' || action === 'View') {
            // For Remove from bucket and View - ALSO check authorization
            const product = data123.find(p => p.attributes.ProductId === item.value);
            return product && product.attributes.Authorized === 'Authorised';
          }
          return true;
        })}
        placeholder={`${label[0]?.attributes.AliasCode}`}
        value={selectedAlias}
        onChange={handleAliasChange}
        style={{ width: 350, marginBottom: 20, marginTop: 20 }}
      /> */}

              <CheckPicker
                data={aliasdata}
                placeholder={`${label[0]?.attributes.AliasCode}`}
                value={selectedAlias}
                onChange={handleAliasChange}
                style={{ width: 350, marginBottom: 20, marginTop: 20 }}
              />

              <CheckPicker
                value={selectedpron}
                onChange={handleProNameChange}
                data={proNamedata}
                placement="autoVerticalStart"
                placeholder={`${label[0]?.attributes.ProductName}`}
                style={{ width: 350, marginBottom: 20 }}
              />

              <CheckPicker
                value={selectedsku}
                onChange={handleSkuChange}
                data={skudata}
                placement="autoVerticalStart"
                placeholder={`${label[0]?.attributes.BuyerSku}`}
                style={{ width: 350, marginBottom: 20 }}
              />

              <CheckPicker
                value={selectedBuyer}
                onChange={handleBuyerChange}
                data={buyernamedata}
                placement="autoVerticalStart"
                placeholder={`${label[0]?.attributes.BuyerName}`}
                style={{ width: 350, marginBottom: 20 }}
              />

              <CheckPicker
                value={selectedFinish}
                onChange={handleFinishChange}
                data={finishdata}
                placement="autoVerticalStart"
                placeholder={`${label[0]?.attributes.finish}`}
                style={{ width: 350, marginBottom: 20 }}
              // onOpen={fetchData4}
              />

              <CheckPicker
                data={colordata}
                placeholder={`${label[0]?.attributes.color}`}
                placement="autoVerticalStart"
                value={selectedColor}
                onChange={handleColorChange}
                style={{ width: 350, marginBottom: 20 }}
              // onOpen={fetchData5}
              />

              <CheckPicker
                value={selectedSearch}
                onChange={handleSearchChange}
                data={searchdata}
                placement="autoVerticalStart"
                placeholder={`${label[0]?.attributes.searchKeyword}`}
                style={{ width: 350, marginBottom: 20 }}
              />

              <CheckPicker
                value={selectedpd}
                onChange={handleProDChange}
                data={proDdata}
                placement="autoVerticalStart"
                placeholder={`${label[0]?.attributes.ProductDesigner}`}
                style={{ width: 350, marginBottom: 20 }}
              />

              <CheckPicker
                value={selectedmade}
                onChange={handleMadeChange}
                data={madedata}
                placement="autoVerticalStart"
                placeholder={`${label[0]?.attributes.MadeBy}`}
                style={{ width: 350, marginBottom: 20 }}
              />

              <CheckPicker
                value={selectedhsn}
                onChange={handleHSNChange}
                data={hsndata}
                placement="autoVerticalStart"
                placeholder={`${label[0]?.attributes.HSN}`}
                style={{ width: 350, marginBottom: 20 }}
              // onOpen={fetchData6}
              />
            </Stack>
          </Drawer.Body>
        </Drawer>

        <Modal size="md" open={openq} onClose={() => setOpenq(false)} backdrop="static">
          <Modal.Body>
            <b style={{ marginBottom: '10px' }}>Print Formats</b>
            <FlexboxGrid justify="space-around">
              <FlexboxGrid.Item as={Col} colspan={24} md={12} style={{ marginBottom: '5px' }}>
                <Button block style={{ height: '18vh' }} onClick={() => handleDownloadQR(action == "View" ? maindata : selectedProducts)} disabled={isQRLoading1} loading={isQRLoading1}>
                  <img src={s2} style={{ width: '45%' }} />
                </Button>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Button
                  block
                  style={{ height: '18vh' }}
                  onClick={() => handleDownloadQR2(action == "View" ? maindata : selectedProducts)}
                  disabled={isQRLoading2}
                  loading={isQRLoading2}
                >
                  <img src={s3} style={{ width: '35%' }} />
                </Button>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Button
                  block
                  style={{ height: '18vh' }}
                  onClick={() => handleDownloadQR3(action == "View" ? maindata : selectedProducts, data1)}
                  disabled={isQRLoading3}
                  loading={isQRLoading3}
                >
                  <img src={s4} style={{ width: '35%' }} />
                </Button>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Button
                  block
                  style={{ height: '18vh' }}
                  onClick={() => handleDownloadQR4(action == "View" ? maindata : selectedProducts, data1)}
                  disabled={isQRLoading4}
                  loading={isQRLoading4}
                >
                  <img src={s4} style={{ width: '35%' }} />
                </Button>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Button
                  block
                  style={{ height: '18vh' }}
                  onClick={() => handleDownloadQR5(action == "View" ? maindata : selectedProducts, data1)}
                  disabled={isQRLoading5}
                  loading={isQRLoading5}
                >
                  <img src={s4} style={{ width: '35%' }} />
                </Button>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Button
                  block
                  style={{ height: '18vh' }}
                  onClick={() => handleDownloadQR6(action == "View" ? maindata : selectedProducts, data1)}
                  disabled={isQRLoading6}
                  loading={isQRLoading6}
                >
                  <img src={s4} style={{ width: '35%' }} />
                </Button>
              </FlexboxGrid.Item>
              {/* <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Button block style={{ height: '18vh' }}>
                  <img src={s1} style={{ width: '74%' }} />
                </Button>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Button block style={{ height: '18vh' }}>
                  <img src={s4} style={{ width: '29%' }} />
                </Button>
              </FlexboxGrid.Item> */}
            </FlexboxGrid>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={submitwithqr} appearance="primary" color="cyan">
              Done
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          size={window.innerWidth >= 746 ? 'full' : 'calc(100% - -7px)'}
          open={openp}
          onClose={handleClose}
        >
          <Modal.Header>
            <Modal.Title>
              <h5>Product Details</h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: '0px' }}>
            {modeldata?.map((item, index) => {
              return (
                <SwiperSlide key={item.id}>
                  <Grid fluid>
                    <Row>
                      <Col lg={12} xs={24} style={{ textAlign: '-webkit-center' }}>
                        <div
                          style={{}}
                          className="arrow arrow-left"
                          onClick={() => handlePrevImage(item)}
                        >
                          <Icon as={ArrowLeftIcon} />
                        </div>
                        <div className="imgp1" style={{ height: '400px', display: 'flex' }}>
                          <ReactImageMagnify
                            {...{
                              className: 'magnify',
                              imageStyle: { objectFit: 'contain' },
                              smallImage: {
                                alt: 'Wristwatch by Ted Baker London',
                                height: 400,
                                width: 400,
                                className: 'magnify',
                                // isFluidWidth: true,

                                src:
                                  selectedImagePath.url && selectedImagePath.id == item.id
                                    ? `${globalIP}${selectedImagePath.url}`
                                    : `${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`
                              },
                              largeImage: {
                                src:
                                  selectedImagePath.url && selectedImagePath.id == item.id
                                    ? `${globalIP}${selectedImagePath.url}`
                                    : `${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`,
                                width: calcwidth,
                                height: 1200
                              },
                              isHintEnabled: true,
                              enlargedImagePosition: 'beside',
                              enlargedImageContainerDimensions: { width: 700, height: 500 }
                            }}
                          />
                        </div>
                        <div
                          style={{}}
                          className="arrow1 arrow-right"
                          onClick={() => handleNextImage(item)}
                        >
                          <Icon as={ArrowRightIcon} />
                        </div>
                        {!item.attributes.MultipleImage.data && (
                          <div style={{ padding: '15px 50px' }}>
                            <Swiper
                              spaceBetween={20}
                              navigation={true}
                              slidesPerView={window.innerWidth >= 746 ? 6 : 3}
                              pagination={{ clickable: true }}
                              modules={[Navigation]}
                              className="nestedSwiper"
                            >
                              <SwiperSlide>
                                <div
                                  style={{
                                    height: '80px',
                                    borderRadius: ' 5px',
                                    overflow: 'hidden',
                                    objectFit: 'contain'
                                  }}
                                >
                                  <img
                                    src={`${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`}
                                    alt=""
                                    style={{
                                      width: '100%',
                                      objectFit: 'contain',
                                      height: '100%'
                                    }}
                                    onClick={() =>
                                      setSelectedImagePath({
                                        url: item?.attributes?.CoverImage?.data?.attributes?.url,
                                        id: item.id,
                                        default: true
                                      })
                                    }
                                  />
                                </div>
                              </SwiperSlide>
                            </Swiper>
                          </div>
                        )}
                        {item.attributes.MultipleImage.data && (
                          <div style={{ padding: '15px 10px' }}>
                            <Swiper
                              spaceBetween={20}
                              navigation={true}
                              slidesPerView={window.innerWidth >= 746 ? 6 : 3}
                              pagination={{ clickable: true }}
                              modules={[Navigation]}
                              className="nestedSwiper"
                            >
                              <SwiperSlide>
                                <div
                                  style={{
                                    height: '80px',
                                    borderRadius: '5px',
                                    objectFit: 'contain',

                                    overflow: 'hidden'
                                  }}
                                  className={
                                    selectedImagePath.url ==
                                      item?.attributes?.CoverImage?.data?.attributes?.url &&
                                      selectedImagePath.id == item.id
                                      ? 'image-product-select image-product-select-active'
                                      : null
                                  }
                                >
                                  <img
                                    src={`${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`}
                                    alt=""
                                    style={{
                                      width: '100%',
                                      objectFit: 'contain',
                                      height: '100%'
                                    }}
                                    onClick={() =>
                                      setSelectedImagePath({
                                        url: item?.attributes?.CoverImage?.data?.attributes?.url,
                                        id: item.id,
                                        default: true
                                      })
                                    }
                                  />
                                </div>
                              </SwiperSlide>
                              {item.attributes.MultipleImage.data &&
                                item.attributes.MultipleImage.data.map(multiImage => {
                                  return (
                                    <SwiperSlide key={multiImage.id}>
                                      <div
                                        style={{
                                          height: '80px',
                                          borderRadius: '5px',
                                          objectFit: 'contain',

                                          overflow: 'hidden'
                                        }}
                                        className={
                                          selectedImagePath.url == multiImage.attributes.url &&
                                            selectedImagePath.id == item.id
                                            ? 'image-product-select image-product-select-active'
                                            : null
                                        }
                                      >
                                        <img
                                          src={`${globalIP}${multiImage.attributes.url}`}
                                          alt=""
                                          style={{
                                            width: '100%',
                                            objectFit: 'contain',
                                            height: '100%'
                                          }}
                                          onClick={() =>
                                            setSelectedImagePath({
                                              url: multiImage.attributes.url,
                                              id: item.id,
                                              default: true
                                            })
                                          }
                                        />
                                      </div>
                                    </SwiperSlide>
                                  );
                                })}
                            </Swiper>
                          </div>
                        )}
                      </Col>
                      <Col lg={12} xs={24}>
                        <div
                          style={{ padding: '10px 20px', marginTop: '-14px' }}
                          className="slide-product-table"
                        >
                          <Stack justifyContent="space-between">
                            <div className="slide-product-name roboto-medium">
                              {item.attributes.ProductName}
                            </div>
                            <Stack direction="column" alignItems="flex-start">
                              <div>Cost(INR): {productCosts[item.id]?.totalinr || 0}</div>
                              <div>
                                Cost({item.attributes.SellingPriceCurrency}):{' '}
                                {productCosts[item.id]?.targetcostUSD || 0}
                              </div>
                              <div>SalePrice(INR): {item.attributes.ProductCost}</div>
                              <div>
                                Cost({item.attributes.SellingPriceCurrency}):{' '}
                                {item.attributes.SellingPrice}
                              </div>
                            </Stack>
                          </Stack>
                          <div className="slide-product-details ">
                            <span className="roboto-medium">Description</span>
                            <p className="roboto-regular">{item.attributes.Description}</p>
                          </div>
                          <Divider className="divide dvd" />

                          {!sizeshow && (
                            <div className="slide-product-dimensions">
                              <div style={{ display: 'flex', alignItems: 'center' }}></div>

                              {item.attributes.SetStatus !== 'Set' && (
                                <div>
                                  <span
                                    className="roboto-medium"
                                    style={{ display: 'flex', alignItems: 'center' }}
                                  >
                                    <p style={{ marginLeft: '0rem', color: '#005c80' }}>LxWxH</p>
                                    <SelectPicker
                                      data={unitOptions}
                                      searchable={false}
                                      defaultValue={selectedUnit}
                                      onChange={handleSizeChange}
                                      size="sm"
                                      cleanable={false}
                                    />
                                  </span>
                                  <p>
                                    {data11[0]?.Length.toFixed(2)} x {data11[0]?.Width.toFixed(2)} x{' '}
                                    {data11[0]?.Height.toFixed(2)} {selectedUnit}
                                  </p>
                                </div>
                              )}
                              <p className="roboto-regular">
                                {(() => {
                                  const isSet = item.attributes.SetStatus === 'Set';

                                  if (isSet) {
                                    const { dimensions, unit } = convertDimensions(
                                      item.attributes.SetSizes.map(({ Length, Width, Height }) => ({
                                        Length,
                                        Width,
                                        Height
                                      })),
                                      item.attributes.SizeUnit
                                      // sizeUnit
                                    );

                                    return (
                                      // <Table
                                      //   height={180}
                                      //   width={550}
                                      //   data={data11}
                                      //   onRowClick={rowData => {
                                      //     // console.log(rowData);
                                      //   }}
                                      //      bordered
                                      // cellBordered
                                      // wordWrap="break-word"
                                      // rowHeight={20}
                                      // >
                                      //   <Column width={100} fixed>
                                      //     <HeaderCell align="center">Part Desc.</HeaderCell>
                                      //     <Cell dataKey="Description" />
                                      //   </Column>

                                      //   <Column width={250}>
                                      //     <HeaderCell style={{ marginTop: '-4px' }} align="center">
                                      //       LxWxH
                                      //       <SelectPicker
                                      //         data={unitOptions}
                                      //         searchable={false}
                                      //         value={selectedUnit}
                                      //         onChange={handleSizeChange}
                                      //         size="xs"
                                      //         cleanable={false}
                                      //         style={{ marginLeft: '8px' }}
                                      //       />
                                      //     </HeaderCell>
                                      //     <Cell>
                                      //       {rowData =>
                                      //         `${rowData.Length.toFixed(2) || 0}x${
                                      //           rowData.Width.toFixed(2) || 0
                                      //         }x${rowData.Height.toFixed(2) || 0} ${
                                      //           rowData.SizeUnit
                                      //         }`
                                      //       }
                                      //     </Cell>
                                      //   </Column>

                                      //   <Column width={100}>
                                      //     <HeaderCell>{label[0]?.attributes.NetWgt}</HeaderCell>
                                      //     <Cell dataKey="NetWt" />
                                      //   </Column>

                                      //   <Column width={100}>
                                      //     <HeaderCell>{label[0]?.attributes.color}</HeaderCell>
                                      //     <Cell dataKey="ColorName" />
                                      //   </Column>
                                      //   {finShow && (
                                      //     <>
                                      //       <Column width={100}>
                                      //         <HeaderCell>Finish</HeaderCell>
                                      //         <Cell dataKey="FinishName" />
                                      //       </Column>

                                      //       <Column width={100}>
                                      //         <HeaderCell>Mat. Name</HeaderCell>
                                      //         <Cell dataKey="MatName" />
                                      //       </Column>
                                      //     </>
                                      //   )}
                                      // </Table>
                                      <Table
                                        height={180}
                                        width={550}
                                        data={data11}
                                        onRowClick={rowData => {
                                          // console.log(rowData);
                                        }}
                                        bordered
                                        cellBordered
                                        wordWrap="break-word"
                                        rowHeight={20}
                                      >
                                        <Column width={120} fixed align="center">
                                          <HeaderCell align="center">
                                            <b>Part Desc.</b>
                                          </HeaderCell>
                                          <Cell dataKey="Description" />
                                        </Column>

                                        <Column width={250} align="center">
                                          <HeaderCell style={{ marginTop: '-4px' }} align="center">
                                            <b>LxWxH</b>
                                            <SelectPicker
                                              data={unitOptions}
                                              searchable={false}
                                              value={selectedUnit}
                                              onChange={handleSizeChange}
                                              size="xs"
                                              cleanable={false}
                                              style={{ marginLeft: '8px' }}
                                            />
                                          </HeaderCell>
                                          <Cell>
                                            {rowData =>
                                              `${rowData.Length.toFixed(2) || 0}x${rowData.Width.toFixed(2) || 0
                                              }x${rowData.Height.toFixed(2) || 0} ${rowData.SizeUnit
                                              }`
                                            }
                                          </Cell>
                                        </Column>

                                        <Column width={100} align="center">
                                          <HeaderCell>
                                            <b>{label[0]?.attributes.NetWgt}</b>
                                          </HeaderCell>
                                          <Cell dataKey="NetWt" />
                                        </Column>

                                        <Column width={100} align="center" align="center">
                                          <HeaderCell>
                                            <b>{label[0]?.attributes.color}</b>
                                          </HeaderCell>
                                          <Cell dataKey="ColorName" />
                                        </Column>
                                        {finShow && (
                                          <>
                                            <Column width={120} align="center">
                                              <HeaderCell>
                                                <b>Finish</b>
                                              </HeaderCell>
                                              <Cell dataKey="FinishName" />
                                            </Column>

                                            <Column width={150} align="center">
                                              <HeaderCell>
                                                <b>Mat. Name</b>
                                              </HeaderCell>
                                              <Cell dataKey="MatName" />
                                            </Column>
                                          </>
                                        )}
                                      </Table>
                                    );
                                  }
                                })()}
                              </p>
                            </div>
                          )}
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">Set Status</div>
                            <div>{item.attributes.SetStatus}</div>
                          </div>
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">
                              {attributesName?.AliasCode || 'Alias Code'}
                            </div>
                            <div>{item.attributes.ProductId}</div>
                          </div>
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">
                              {attributesName?.Category || 'Category'}
                            </div>
                            <div>{item.attributes.CategoryName}</div>
                          </div>
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">
                              {attributesName?.ProductType || 'Product Type'}
                            </div>
                            <div>{item.attributes.ProductTypeName}</div>
                          </div>
                          {item.attributes.SetStatus !== 'Set' && (
                            <div className="slide-product-Alias ">
                              <div className="roboto-medium">
                                {attributesName?.finish || 'Finish'}
                              </div>
                              <div>{item.attributes.FinishName}</div>
                            </div>
                          )}
                          {item.attributes.SetStatus !== 'Set' && (
                            <div className="slide-product-Alias ">
                              <div className="roboto-medium">
                                {attributesName?.color || 'Color'}
                              </div>
                              <div>{item.attributes.ColorName}</div>
                            </div>
                          )}
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">{attributesName?.cbm || 'CBM'}</div>
                            <div>{item.attributes.Total_CBM}</div>
                          </div>
                          {sizeshow && (
                            <div className="slide-product-Alias ">
                              <div className="roboto-medium">
                                {attributesName?.SizeRange || 'Free Size'}
                              </div>
                              <div>{item.attributes.SizeRange}</div>
                            </div>
                          )}
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">
                              {attributesName?.GrossWgt || 'Gross Weight'}
                            </div>
                            <div>{item.attributes.GrossWeight}</div>
                          </div>
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">
                              {attributesName?.NetWgt || 'Net Weight'}
                            </div>
                            <div>{item.attributes.NetWeight}</div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Grid>
                </SwiperSlide>
              );
            })}
          </Modal.Body>
        </Modal>
        <Stack
          className="copyright"
          justifyContent="flex-end"
          spacing={5}
          style={{
            position: 'fixed',
            bottom: '0',
            width: '-webkit-fill-available',
            textAlign: 'center',
            backgroundColor: 'white',
            paddingRight: '16px'
          }}
        >
          <p>© All Right Reserved. Product by </p>
          <p>
            {' '}
            <a href="https://erpdaddy.com/" target="_blank">
              ERP Daddy Softwere Solution.
            </a>
          </p>
        </Stack>
      </Container>
      {open && (
        <ModalComponent
          open={open}
          onClose={() => {
            setOpen(false);
            setCurrentPage(1); // ✅ Reset page
            setData123([]);
            fetchDataFair();
          }}
          fairdata={fairdata}
          fairStatuses={fairStatuses}
          fairmeta={fairmeta}
          setFairData={setFairData}
          fetchDataEnc={fetchDataEnc}
        />
      )}
    </>
  );
};

export default ManageFair;
